import React, { useState, useEffect } from 'react'
import {
  Card,
  Button,
  Input,
  Divider,
  Row,
  Modal,
  Col,
  Tag,
  Checkbox,
  message,
  Form,
  AutoComplete,
  Select,
  Spin,
  Alert,
  DatePicker,
  Space,
  Radio,
  InputNumber,
  Menu,
  Dropdown,
  TimePicker
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  SearchOutlined,
  TagFilled,
  DownOutlined,
  PlusCircleOutlined,
  FunnelPlotOutlined
} from '@ant-design/icons'
import { InputGroup } from 'reactstrap'
import moment from 'moment'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import PromoCodes from './PromoCodes'
import {
  loadPromoCodesModal,
  loadSearchSelectedProduct
} from '../../../appRedux/actions/Products'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { PROMOTION } from '../../../constants/Pages'
import { Promotions } from '../../../constants/SubscriptionPermissions'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  getDecryptID,
  checkSubPerm,
  StringIsNullOrEmpty,
  getEncryptedID,
  checkExpiresSub,
  isString,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  AUTOCOMPLETE_SEARCH_FROM,
  PROD_SEARCH_ENTITIES
} from '../../../constants/ProductSearch'
import ProductSearch from '../../../components/ProductSearch'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const { RangePicker } = DatePicker
const { Option } = Select
const additionalYears = 5

const PromoAdd = ({ match }) => {
  const promoID = match.params.id
  const history = useHistory()
  const store = useStore()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxPromoCodes = useSelector(({ Products }) => Products.promoCodes)
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getSubPerm = useSelector(
    ({ commonConfigs }) => commonConfigs.getSubPerm
  )
  const getIsTrial = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsTrial
  )
  const getIsEnterprise = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsEnterprise
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )

  const [cardPromoName, setcardPromoName] = useState(
    <IntlMessages id='products.promoadd.promoname' />
  )
  const [getPromoDescPlace, setPromoDescPlace] = useState(
    <IntlMessages id='products.promoadd.promodescplace' />
  )
  const [getIsBasic, setIsBasic] = useState(true)
  const [getIsEveryone, setIsEveryone] = useState(true)
  const [selectedTestType, setselectedTestType] = useState('1')
  const [selectedCus, setselectedCus] = useState('1')
  const [getBasicIsPercent, setBasicIsPercent] = useState(true)
  const [getRewardSaveIsPercent, setRewardSaveIsPercent] = useState(true)
  const [getBasicIsAll, setBasicIsAll] = useState(true)
  const [getBasicDisCardBtn, setBasicDisCardBtn] = useState('Percent')
  const [getRewardDisCardBtn, setRewardDisCardBtn] = useState('Percent')
  const [getRewardSaveBtn, setRewardSaveBtn] = useState('Percent')
  const [getBasicDisCardProd, setBasicDisCardProd] = useState('All')
  const [getShortCurr, setShortCurr] = useState('')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [searchDropBtnName, setSearchDropBtnName] = useState(
    PROD_SEARCH_ENTITIES.Search_By_Product
  )
  const [getDropBtnName, setDropBtnName] = useState(
    <IntlMessages id='products.promoadd.include' />
  )
  const [getDropBtnNameForReward, setDropBtnNameForReward] = useState(
    <IntlMessages id='products.promoadd.include' />
  )
  const [getBasicPromoOptions, setBasicPromoOptions] = useState([])
  const [selectedBasicPromoAdd, setSelectedBasicPromoAdd] = useState([])
  const [selectedAdvanceBuyPromoAdd, setSelectedAdvanceBuyPromoAdd] = useState(
    []
  )
  const [selectedBasicPromoAddExtraBtn, setSelectedBasicPromoAddExtraBtn] =
    useState([])
  const [selectedAdvBuyPromoAddExtraBtn, setSelectedAdvBuyPromoAddExtraBtn] =
    useState([])
  const [getBasicPromoSearchProd, setBasicPromoSearchProd] = useState([])
  const [getIsExclude, setIsExclude] = useState(false)
  const [getAdvanceBuyIsExclude, setAdvanceBuyIsExclude] = useState(false)
  const [getWhichOptionSelect, setWhichOptionSelect] = useState(
    <IntlMessages id='products.promoadd.exclude' />
  )
  const [getWhichOptionSelectForReward, setWhichOptionSelectForReward] =
    useState(<IntlMessages id='products.promoadd.exclude' />)
  //const [getIsBasicProdAdded, setIsBasicProdAdded] = useState(false);
  const [getIsAdvance, setIsAdvance] = useState(false)
  const [getIsWhenCusBuy, setIsWhenCusBuy] = useState(false)
  const [getIsWhenCusSpend, setIsWhenCusSpend] = useState(false)
  const [getWhenCusDropValue, setWhenCusDropValue] = useState(
    <IntlMessages id='products.promoadd.whencusplaceholder' />
  )
  const [getRewardDropValue, setRewardDropValue] = useState(
    <IntlMessages id='products.promoadd.rewardplaceholder' />
  )
  const [getAdvanceBuyCardProd, setAdvanceBuyCardProd] = useState('All')
  const [getAdvanceRewardCardProd, setAdvanceRewardCardProd] = useState('All')
  const [getAdvanceSpendCardProd, setAdvanceSpendCardProd] = useState('All')
  const [getAdvanceBuyIsAll, setAdvanceBuyIsAll] = useState(true)
  const [getAdvanceRewardIsAll, setAdvanceRewardIsAll] = useState(true)
  const [getAdvanceSpendIsAll, setAdvanceSpendIsAll] = useState(true)
  const [getRewards, setRewards] = useState([])
  const [
    getIdentifyWhenCusDropDownSelection,
    setIdentifyWhenCusDropDownSelection
  ] = useState(0)
  const [getIsShowPromptOnSellScreen, setIsShowPromptOnSellScreen] =
    useState(false)
  const [getIsRewardGetKind, setIsRewardGetKind] = useState(false)
  const [getIsRewardSave, setIsRewardSave] = useState(false)
  const [getIsRewardFixed, setIsRewardFixed] = useState(false)
  const [getIsReward, setIsReward] = useState(false)
  const [getIsRewardGetFree, setIsRewardGetFree] = useState(false)
  const [getIsRewardGetPercent, setIsRewardGetPercent] = useState(true)
  const [getIsRewardGetAmount, setIsRewardGetAmount] = useState(false)
  const [getExclusiveCusValue, setExclusiveCusValue] = useState(1)
  const [selectedAdvanceSpendPromoAdd, setSelectedAdvanceSpendPromoAdd] =
    useState([])
  const [selectedAdvanceRewardAdd, setSelectedAdvanceRewardAdd] = useState([])
  const [getAdvanceSpendIsExclude, setAdvanceSpendIsExclude] = useState(false)
  const [getAdvanceRewardIsExclude, setAdvanceRewardIsExclude] = useState(false)
  const [
    selectedAdvSpendPromoAddExtraBtn,
    setSelectedAdvSpendPromoAddExtraBtn
  ] = useState([])
  const [selectedAdvRewardAddExtraBtn, setSelectedAdvRewardAddExtraBtn] =
    useState([])
  const [getIsRewardInfoToShow, setIsRewardInfoToShow] = useState(false)
  const [getCustomersData, setCustomersData] = useState([])
  const [getOutletsData, setOutletsData] = useState([])
  const [getOutletsDeSelect, setOutletsDeSelect] = useState([])
  const [getCusGroupsDeSelect, setCusGroupsDeSelect] = useState([])
  //const [getPromoData, setPromoData] = useState([]);
  //const [getBasicDisPerValue, setBasicDisPerValue] = useState(0);
  //const [getRewardSavePerValue, setRewardSavePerValue] = useState(0);
  //const [getRewardSaveAmountValue, setRewardSaveAmountValue] = useState(0);
  //const [getRewardFixAmountValue, setRewardFixAmountValue] = useState(0);
  //const [getRewardGetAmountValue, setRewardGetAmountValue] = useState(0);
  //const [getRewardPercentVal, setRewardPercentVal] = useState(0);
  //const [getBasicDisAmountValue, setBasicDisAmountValue] = useState(0);
  const [getIncludeExcludeIdentifier, setIncludeExcludeIdentifier] = useState(1)
  const [
    getIncludeExcludeIdentifierForReward,
    setIncludeExcludeIdentifierForReward
  ] = useState(1)
  //const [getAdvBuyItemQuantity, setAdvBuyItemQuantity] = useState(0);
  //const [getAdvRewardGetQuantityQuantity, setAdvRewardGetQuantityQuantity] = useState(0);
  //const [getAdvRewardGetFreeQuantity, setAdvRewardGetFreeQuantity] = useState(0);
  //const [getAdvRewardGetItemQuantity, setAdvRewardGetItemQuantity] = useState(0);
  //const [getAdvSpendAmount, setAdvSpendAmount] = useState(0);
  const [getIsPromoCodeVisible, setIsPromoCodeVisible] = useState(0)
  const [getUserOutlets, setUserOutlets] = useState([])
  const [getUserCusGroups, setUserCusGroups] = useState([])
  const [getUserPromoProd, setUserPromoProd] = useState([])
  const [getUserRewardProd, setUserRewardProd] = useState([])
  const [getDeSelectedPromoProd, setDeSelectedPromoProd] = useState([])
  const [getDeSelectedRewardProd, setDeSelectedRewardProd] = useState([])
  const [getIsSpinning, setIsSpinning] = useState(true)
  const [getAutoCompleteError, setAutoCompleteError] = useState(false)
  const [getRewardAutoCompleteError, setRewardAutoCompleteError] =
    useState(false)
  const [getCurrData, setCurrData] = useState({})
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [advPromoAllow, setAdvPromoAllow] = useState(false)
  const [radioDatePick, setRadioDatePick] = useState(1)
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  // const [selectedDay, setSelectedDay] = useState(null)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.Promotions)) {
        setIsFeatureAllowed(false)
      }
      dispatch(setCommonConfigs(PROMOTION))
      getPromotion(PkgFeatures.Promotions)
    }
    return () => {
      mounted = false
    }
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      setIsSpinning(true)
      const res = checkSubPerm(
        getSubPerm,
        getIsTrial,
        getIsEnterprise,
        Promotions
      )
      if (res) {
        setSubPerm(res)
      }
      setIsSpinning(false)
    }

    return () => (mounted = false)
  }, [getSubPerm])

  //for common data -> store currency
  // React.useEffect(() => {
  //   let commonData = getReduxCommonSetting;
  //   if (
  //     commonData &&
  //     commonData.storeCommonConfigs &&
  //     commonData.storeCommonConfigs.storeConfig &&
  //     commonData.storeCommonConfigs.storeConfig.currencyData
  //   ) {
  //     let currencyData = commonData.storeCommonConfigs.storeConfig.currencyData;
  //     setCurrSymbol(currencyData.currencySymbol);
  //     setShortCurr(currencyData.currencyCode);
  //     setCurrData(currencyData);
  //   }
  // }, [getReduxCommonSetting]);

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      if (getSearchSelectedProduct) {
        // let data = { ...getSearchSelectedProduct }
        // if (data.productID) {
        //   data.productID = getEncryptedID(data.productID)
        // }

        if (
          getSearchSelectedProduct.searchFrom ===
          AUTOCOMPLETE_SEARCH_FROM.BASICPROMO
        ) {
          onBasicPromoAddSelect(getSearchSelectedProduct)
        }
        if (
          getSearchSelectedProduct.searchFrom ===
          AUTOCOMPLETE_SEARCH_FROM.BASICPROMOEXTRA
        ) {
          onBasicPromoExtraBtnAddSelect(getSearchSelectedProduct)
        }
        if (
          getSearchSelectedProduct.searchFrom ===
          AUTOCOMPLETE_SEARCH_FROM.ADVANCEBUYPROMO
        ) {
          onAdvanceBuyPromoAddSelect(getSearchSelectedProduct)
        }
        if (
          getSearchSelectedProduct.searchFrom ===
          AUTOCOMPLETE_SEARCH_FROM.ADVANCEBUYPROMOEXTRA
        ) {
          onAdvBuyPromoExtraBtnAddSelect(getSearchSelectedProduct)
        }
        if (
          getSearchSelectedProduct.searchFrom ===
          AUTOCOMPLETE_SEARCH_FROM.ADVANCESPENDPROMO
        ) {
          onAdvanceSpendPromoAddSelect(getSearchSelectedProduct)
        }
        if (
          getSearchSelectedProduct.searchFrom ===
          AUTOCOMPLETE_SEARCH_FROM.ADVANCESPENDPROMOEXTRA
        ) {
          onAdvSpendPromoExtraBtnAddSelect(getSearchSelectedProduct)
        }
        if (
          getSearchSelectedProduct.searchFrom ===
          AUTOCOMPLETE_SEARCH_FROM.REWARDADD
        ) {
          onRewardAddSelect(getSearchSelectedProduct)
        }
        if (
          getSearchSelectedProduct.searchFrom ===
          AUTOCOMPLETE_SEARCH_FROM.ADVREWARDEXTRA
        ) {
          onAdvRewardExtraBtnAddSelect(getSearchSelectedProduct)
        }
      }
    }
    return () => (mounted = false)
  }, [getSearchSelectedProduct])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setSubPerm (res) {
    setAdvPromoAllow(res ? res : false)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  async function getPromotion (featureID) {
    let supposedBody = promoID
      ? {
          IsEdit: true,
          PromotionID: promoID
        }
      : { IsAdd: true }
    const getUpcommingData = ds.getPromotions(supposedBody, BEHAVIOUR_TYPE.GET, featureID)
    await getUpcommingData
      .then(res => {
        setIsSpinning(false)
        if (res.data.data.customers.length > 0) {
          let mappedCus = res.data.data.customers.map(cus => {
            return {
              id: cus.customerID,
              name: cus.customerGroupName
            }
          })
          setCustomersData(mappedCus)
          //mapped.sort((a, b) => (a.createdon < b.createdon) ? 1 : -1);
        }
        if (res.data.data.rewards.length > 0) {
          let mappedRew = res.data.data.rewards.map(rew => {
            return {
              id: rew.rewardID,
              name: rew.rewardName
            }
          })
          // mappedRew = mappedRew && mappedRew.length > 0 ? mappedRew.filter(a => getDecryptID(a.id) != '1') : [];
          setRewards(mappedRew)
        }
        if (res.data.data.outlets.length > 0) {
          let mappedOut = res.data.data.outlets.map(out => {
            return {
              id: out.outletID,
              name: out.outletName
            }
          })
          setOutletsData(mappedOut)
        }

        //forEdit
        if (promoID) {
          if (res.data.data.promotions.length > 0) {
            let mappedPromo = res.data.data.promotions.map(promo => {
              return {
                id: promo.promotionID,
                name: promo.promoName,
                startDate: promo.startAt,
                endDate: promo.endAt,
                desc: promo.promoDesc,
                availOn: promo.availableOn,
                onGroups: promo.onGroups,
                rewID: promo.rewardID,
                rewName: promo.rewardName,
                isBasic: promo.isBasic,
                isDisPer: promo.isDiscountPercent,
                isDisAmount: promo.isDiscountAmount,
                isAdvance: promo.isAdvance,
                isAdvBuy: promo.isAdvanceBuy,
                isAdvSpend: promo.isAdvanceSpend,
                basicDisAmount: promo.basicDiscountAmount,

                basicDisPer: promo.basicDiscountPercent,
                advBuyItemQuantity: promo.advanceBuyItemsQuantity,
                advSpendAmount: promo.advanceSpendAmount,
                isShowPrmoptSell: promo.isShowPromptSell,
                isAvailableToAll: promo.isAvailableToEveryone,
                isPromoCodes: promo.isPromoCodes,
                isAllProd: promo.isAllProducts,
                isAllRewProd: promo.isAllRewardProducts,
                createdOn: promo.createdOn,

                promoProd: promo.promoProducts,
                rewProd: promo.rewardProducts,
                promoOut: promo.promoOutlets,
                promoCus: promo.promoCustomers,
                rewSpecifications: promo.rewardSpecifications,
                day: promo.day
              }
            })

            if (mappedPromo.length > 0) {
              if (match.path.includes('edit')) {
                form.setFieldsValue({ promoName: mappedPromo[0].name })
                setcardPromoName(mappedPromo[0].name)

                if (mappedPromo[0].isPromoCodes) {
                  setIsEveryone(false)
                  setExclusiveCusValue(2)
                  setselectedCus('2')
                }
              }
              form.setFieldsValue({ description: mappedPromo[0].desc })
              setPromoDescPlace(mappedPromo[0].desc)
              form.setFieldsValue({ description: mappedPromo[0].desc })
              if (mappedPromo[0].day) {
                form.setFieldsValue({
                  daySelection: mappedPromo[0].day
                })
                setRadioDatePick(2)
              }
              if (mappedPromo[0].startDate) {
                if (mappedPromo[0].day) {
                  form.setFieldsValue({
                    timeRange: [
                      moment(mappedPromo[0].startDate),
                      moment(mappedPromo[0].endDate)
                    ]
                  })
                } else {
                  form.setFieldsValue({
                    formDate: [
                      moment(mappedPromo[0].startDate),
                      moment(mappedPromo[0].endDate)
                    ]
                  })
                }
              }
              let initOutlet =
                mappedPromo[0].promoOut &&
                mappedPromo[0].promoOut.length > 0 &&
                mappedPromo[0].promoOut.map(e => e.outletName)
              if (initOutlet && initOutlet.length > 0) {
                setUserOutlets(mappedPromo[0].promoOut)
                form.setFieldsValue({ outlets: initOutlet })
              }

              //for type promotion
              if (mappedPromo[0].isBasic) {
                setIsBasic(mappedPromo[0].isBasic)
                if (mappedPromo[0].basicDisPer) {
                  form.setFieldsValue({
                    disPercent: mappedPromo[0].basicDisPer
                  })
                }
                if (mappedPromo[0].basicDisAmount) {
                  form.setFieldsValue({
                    disCurrency: mappedPromo[0].basicDisAmount
                  })
                  setBasicIsPercent(false)
                  setBasicDisCardBtn('Currency')
                }
              } else if (mappedPromo[0].isAdvance) {
                setIsBasic(false)
                setselectedTestType(2)
                setIsAdvance(mappedPromo[0].isAdvance)
                setIsReward(true)

                if (mappedPromo[0].isAdvBuy) {
                  setWhenCusDropValue(
                    <IntlMessages id='products.promoadd.whencus1' />
                  )
                  setIsWhenCusBuy(true)
                  if (mappedPromo[0].advBuyItemQuantity) {
                    form.setFieldsValue({
                      advBuyQuantity: mappedPromo[0].advBuyItemQuantity
                    })
                  }
                } else if (mappedPromo[0].isAdvSpend) {
                  setWhenCusDropValue(
                    <IntlMessages id='products.promoadd.whencus2' />
                  )
                  setIsWhenCusSpend(true)
                  if (mappedPromo[0].advSpendAmount) {
                    form.setFieldsValue({
                      advSpendAmount: mappedPromo[0].advSpendAmount
                    })
                  }
                }

                if (mappedPromo[0].rewName) {
                  form.setFieldsValue({
                    rewards: [mappedPromo[0].rewName, mappedPromo[0].rewID]
                  })
                }

                //for reward specifications
                if (mappedPromo[0].rewSpecifications) {
                  if (mappedPromo[0].rewSpecifications.isGetItems) {
                    setIsRewardGetKind(true)
                    setIsRewardSave(false)
                    setIsRewardFixed(false)
                    if (mappedPromo[0].rewSpecifications.discountPercent) {
                      form.setFieldsValue({
                        rewGetPercent:
                          mappedPromo[0].rewSpecifications.discountPercent
                      })
                      if (mappedPromo[0].rewSpecifications.quantity) {
                        form.setFieldsValue({
                          rewGetDiscount:
                            mappedPromo[0].rewSpecifications.quantity
                        })
                      }
                    } else if (mappedPromo[0].rewSpecifications.isFree) {
                      setIsRewardGetFree(true)
                      setIsRewardGetAmount(false)
                      setIsRewardGetPercent(false)
                      setRewardDisCardBtn('Free')
                      if (mappedPromo[0].rewSpecifications.quantity) {
                        form.setFieldsValue({
                          rewGetFree: mappedPromo[0].rewSpecifications.quantity
                        })
                      }
                    } else if (
                      mappedPromo[0].rewSpecifications.discountAmount
                    ) {
                      setIsRewardGetFree(false)
                      setIsRewardGetAmount(true)
                      setIsRewardGetPercent(false)
                      setRewardDisCardBtn('Currency')
                      form.setFieldsValue({
                        rewGetAmount:
                          mappedPromo[0].rewSpecifications.discountAmount
                      })
                      if (mappedPromo[0].rewSpecifications.quantity) {
                        form.setFieldsValue({
                          rewGetAmountDis:
                            mappedPromo[0].rewSpecifications.quantity
                        })
                      }
                    }
                  } else if (mappedPromo[0].rewSpecifications.isFixPay) {
                    setIsRewardGetKind(false)
                    setIsRewardSave(false)
                    setIsRewardFixed(true)
                    if (mappedPromo[0].rewSpecifications.fixedPriceAmount) {
                      form.setFieldsValue({
                        rewFixAmount:
                          mappedPromo[0].rewSpecifications.fixedPriceAmount
                      })
                    }
                  } else if (mappedPromo[0].rewSpecifications.isSave) {
                    setIsRewardGetKind(false)
                    setIsRewardSave(true)
                    setIsRewardFixed(false)
                    if (mappedPromo[0].rewSpecifications.savePercent) {
                      setRewardSaveIsPercent(true)
                      form.setFieldsValue({
                        rewSavePercent:
                          mappedPromo[0].rewSpecifications.savePercent
                      })
                    } else if (mappedPromo[0].rewSpecifications.saveAmount) {
                      setRewardSaveIsPercent(false)
                      setRewardSaveBtn('Currency')
                      form.setFieldsValue({
                        rewSaveAmount:
                          mappedPromo[0].rewSpecifications.saveAmount
                      })
                    }
                  }
                }

                if (mappedPromo[0].isShowPrmoptSell) {
                  setIsShowPromptOnSellScreen(mappedPromo[0].isShowPrmoptSell)
                }
              }

              //for promo products
              if (
                !mappedPromo[0].isAllProd &&
                mappedPromo[0].promoProd.length > 0
              ) {
                setUserPromoProd(mappedPromo[0].promoProd)
                let isIncludeExist = mappedPromo[0].promoProd.filter(
                  a => a.isInclude === true
                )
                let isExcludeExist = mappedPromo[0].promoProd.filter(
                  a => a.isExclude === true
                )
                if (isIncludeExist && isIncludeExist.length > 0) {
                  isIncludeExist.map(a => {
                    if (a.__ProductID) {
                      a.productID = a.__ProductID
                    }
                  })
                }
                if (isExcludeExist && isExcludeExist.length > 0) {
                  isExcludeExist.map(a => {
                    if (a.__ProductID) {
                      a.productID = a.__ProductID
                    }
                  })
                }
                if (mappedPromo[0].isBasic) {
                  setBasicDisCardProd('Specific')
                  setBasicIsAll(mappedPromo[0].isAllProd)
                  if (isIncludeExist.length > 0) {
                    setSelectedBasicPromoAdd(isIncludeExist)
                  }
                  if (isExcludeExist.length > 0) {
                    setIsExclude(true)
                    setSelectedBasicPromoAddExtraBtn(isExcludeExist)
                    // setIncludeExcludeIdentifier(2);
                  }
                } else if (mappedPromo[0].isAdvance) {
                  if (mappedPromo[0].isAdvBuy) {
                    setAdvanceBuyCardProd('Specific')
                    setAdvanceBuyIsAll(mappedPromo[0].isAllProd)

                    if (isIncludeExist.length > 0) {
                      setSelectedAdvanceBuyPromoAdd(isIncludeExist)
                    }
                    if (isExcludeExist.length > 0) {
                      // setIncludeExcludeIdentifier(2);
                      setAdvanceBuyIsExclude(true)
                      setSelectedAdvBuyPromoAddExtraBtn(isExcludeExist)
                    }
                  } else if (mappedPromo[0].isAdvSpend) {
                    setAdvanceSpendCardProd('Specific')
                    setAdvanceSpendIsAll(mappedPromo[0].isAllProd)

                    if (isIncludeExist.length > 0) {
                      setSelectedAdvanceSpendPromoAdd(isIncludeExist)
                    }
                    if (isExcludeExist.length > 0) {
                      // setIncludeExcludeIdentifier(2);
                      setAdvanceSpendIsExclude(true)
                      setSelectedAdvSpendPromoAddExtraBtn(isExcludeExist)
                    }
                  }
                }

                ///////////

                // if (isIncludeExist && isExcludeExist) {
                //   if (mappedPromo[0].isBasic) {
                //     setBasicDisCardProd("Specific");
                //     setBasicIsAll(mappedPromo[0].isAllProd);
                //     setIsExclude(true);
                //     //isInclude products
                //     setSelectedBasicPromoAdd(isIncludeExist);
                //     //isExclude products
                //     setSelectedBasicPromoAddExtraBtn(isExcludeExist);
                //   } else if (mappedPromo[0].isAdvance) {
                //     if (mappedPromo[0].isAdvBuy) {
                //       setAdvanceBuyCardProd("Specific");
                //       setAdvanceBuyIsAll(mappedPromo[0].isAllProd);
                //       setAdvanceBuyIsExclude(true);
                //       setSelectedAdvanceBuyPromoAdd(isIncludeExist);
                //       setSelectedAdvBuyPromoAddExtraBtn(isExcludeExist);
                //     } else if (mappedPromo[0].isAdvSpend) {
                //       setAdvanceSpendCardProd("Specific");
                //       setAdvanceSpendIsAll(mappedPromo[0].isAllProd);
                //       setAdvanceSpendIsExclude(true);
                //       setSelectedAdvanceSpendPromoAdd(isIncludeExist);
                //       setSelectedAdvSpendPromoAddExtraBtn(isExcludeExist);
                //     }
                //   }
                // } else if (isIncludeExist && !isExcludeExist) {
                //   if (mappedPromo[0].isBasic) {
                //     setBasicDisCardProd("Specific");
                //     setBasicIsAll(mappedPromo[0].isAllProd);
                //     setSelectedBasicPromoAdd(isIncludeExist);
                //   } else if (mappedPromo[0].isAdvance) {
                //     if (mappedPromo[0].isAdvBuy) {
                //       setAdvanceBuyCardProd("Specific");
                //       setAdvanceBuyIsAll(mappedPromo[0].isAllProd);
                //       setSelectedAdvanceBuyPromoAdd(isIncludeExist);
                //     } else if (mappedPromo[0].isAdvSpend) {
                //       setAdvanceSpendCardProd("Specific");
                //       setAdvanceSpendIsAll(mappedPromo[0].isAllProd);
                //       setSelectedAdvanceSpendPromoAdd(isIncludeExist);
                //     }
                //   }
                // } else if (!isIncludeExist && isExcludeExist) {
                //   setIncludeExcludeIdentifier(2);
                //   setDropBtnName(
                //     <IntlMessages id="products.promoadd.exclude" />
                //   );
                //   setWhichOptionSelect(
                //     <IntlMessages id="products.promoadd.include" />
                //   );
                //   if (mappedPromo[0].isBasic) {
                //     setBasicDisCardProd("Specific");
                //     setBasicIsAll(mappedPromo[0].isAllProd);
                //     setSelectedBasicPromoAddExtraBtn(isExcludeExist);
                //   } else if (mappedPromo[0].isAdvance) {
                //     if (mappedPromo[0].isAdvBuy) {
                //       setAdvanceBuyCardProd("Specific");
                //       setAdvanceBuyIsAll(mappedPromo[0].isAllProd);
                //       setSelectedAdvBuyPromoAddExtraBtn(isExcludeExist);
                //     } else if (mappedPromo[0].isAdvSpend) {
                //       setAdvanceSpendCardProd("Specific");
                //       setAdvanceSpendIsAll(mappedPromo[0].isAllProd);
                //       setSelectedAdvSpendPromoAddExtraBtn(isExcludeExist);
                //     }
                //   }
                // }
              }

              //for rewards products
              if (
                !mappedPromo[0].isAllRewProd &&
                mappedPromo[0].rewProd.length > 0
              ) {
                setUserRewardProd(mappedPromo[0].rewProd)
                const isIncludeExist = mappedPromo[0].rewProd.filter(
                  a => a.isInclude == true
                )
                const isExcludeExist = mappedPromo[0].rewProd.filter(
                  a => a.isExclude == true
                )

                setAdvanceRewardCardProd('Specific')
                setAdvanceRewardIsAll(mappedPromo[0].isAllProd)
                if (isIncludeExist.length > 0) {
                  setSelectedAdvanceRewardAdd(isIncludeExist)
                  setSelectedAdvanceRewardAdd(isIncludeExist)
                }
                if (isExcludeExist.length > 0) {
                  setAdvanceRewardIsExclude(true)
                  setSelectedAdvRewardAddExtraBtn(isExcludeExist)
                  // setIncludeExcludeIdentifierForReward(2);
                }
              }

              //for target promo
              if (!mappedPromo[0].isAvailableToAll) {
                setIsEveryone(mappedPromo[0].isAvailableToAll)
                setselectedCus(2)
                let initCustomers =
                  mappedPromo[0].promoCus &&
                  mappedPromo[0].promoCus.length > 0 &&
                  mappedPromo[0].promoCus.map(e => e.customerGroupName)
                if (initCustomers && initCustomers.length > 0) {
                  setUserCusGroups(mappedPromo[0].promoCus)
                  form.setFieldsValue({ customers: initCustomers })
                }
              } else {
                setUserCusGroups(mappedPromo[0].promoCus)
              }
            }
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsSpinning(false)
      })
  }

  async function postPromotion (body, methodType, featureID) {
    const postPromo = ds.addUpdateDeletePromotion(body, methodType, featureID)
    await postPromo
      .then(res => {
        setIsSpinning(false)
        if (res.data.msgCode == 'GENERAL_SUCCESS') {
          if (res.data.data === 'Input Data Missing') {
            message.error('Kindly attend to wrong information')
          } else if (res.data.data.includes('Deleted')) {
            message.success(
              `Successfully deleted "} ` + form.getFieldValue('promoName')
            )
            setTimeout(() => {
              history.push(`/Dashboard/products/promotions/listing`)
            }, 1000)
          } else if (res.data.data.includes('Promotion')) {
            message.success(
              `Successfully ${promoID ? 'Updated' : 'Created Promotion '} ` +
                form.getFieldValue('promoName')
            )
            setTimeout(() => {
              history.push(`/Dashboard/products/promotions/listing`)
            }, 1000)
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsSpinning(false)
      })
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const disocuntOptions = [
    { label: '%', value: 'Percent' },
    { label: getShortCurr, value: 'Currency' }
  ]

  const rewardDisocuntOptions = [
    { label: 'Free', value: 'Free' },
    { label: '%', value: 'Percent' },
    { label: getShortCurr, value: 'Currency' }
  ]

  const productsOptions = [
    { label: 'All', value: 'All' },
    { label: 'Specific', value: 'Specific' }
  ]

  const cardClickFunction = value => {
    if (value == 1) {
      setIsBasic(true)
      setIsAdvance(false)
      setselectedTestType(1)
      setIsWhenCusBuy(false)
      setIsWhenCusSpend(false)

      if (getIsReward) {
        setIsRewardInfoToShow(true)
      } else {
        setIsRewardInfoToShow(false)
      }

      setIsReward(false)
    } else if (value == 2) {
      setIsBasic(false)
      setIsAdvance(true)
      setselectedTestType(2)
      if (getIdentifyWhenCusDropDownSelection === 1) {
        setIsWhenCusBuy(true)
      } else if (getIdentifyWhenCusDropDownSelection === 2) {
        setIsWhenCusSpend(true)
      }
      if (getIsRewardInfoToShow) {
        setIsReward(true)
      }
    }
  }

  const secondCardClickFunction = value => {
    if (value == 1) {
      setIsEveryone(true)
      setselectedCus(1)
    } else if (value == 2) {
      //if editing and changing from isEveryone to specific, all customer groups would be present by default
      let allCustomerGroup = 'All Customer Groups'
      let isExist =
        getUserCusGroups &&
        getUserCusGroups.length > 0 &&
        getUserCusGroups.filter(a => a.customerGroupName == allCustomerGroup)
      if (isExist && isExist.length > 0) {
        form.setFieldsValue({ customers: [allCustomerGroup] })
      }
      setIsEveryone(false)
      setselectedCus(2)
      //setExclusiveCusValue(1);
    }
  }

  const prodDropDown = (
    <Menu onClick={handleDropDownClick}>
      <Menu.Item key='1' icon={<FunnelPlotOutlined />}>
        <IntlMessages id='products.promoadd.include' />
      </Menu.Item>

      <Menu.Item key='2' icon={<FunnelPlotOutlined />}>
        <IntlMessages id='products.promoadd.exclude' />
      </Menu.Item>
    </Menu>
  )
  const searchDropDown = (
    <Menu selectedKeys={[searchDropBtnName]} onClick={searchDropDownClick}>
      {Object.entries(PROD_SEARCH_ENTITIES).map((a, key) => {
        return (
          <Menu.Item key={a[1]} icon={<FunnelPlotOutlined />}>
            {a[0].replaceAll('_', ' ')}
          </Menu.Item>
        )
      })}
    </Menu>
  )

  function searchDropDownClick (e) {
    setSearchDropBtnName(e.key ? e.key : PROD_SEARCH_ENTITIES.Search_By_Product)
  }

  const prodDropDownForReward = (
    <Menu onClick={handleDropDownClickForReward}>
      <Menu.Item key='1' icon={<FunnelPlotOutlined />}>
        <IntlMessages id='products.promoadd.include' />
      </Menu.Item>

      <Menu.Item key='2' icon={<FunnelPlotOutlined />}>
        <IntlMessages id='products.promoadd.exclude' />
      </Menu.Item>
    </Menu>
  )

  const getWhenCustomer = [
    {
      whenCusID: 1,
      whenCusName: <IntlMessages id='products.promoadd.whencus1' />
    },
    {
      whenCusID: 2,
      whenCusName: <IntlMessages id='products.promoadd.whencus2' />
    }
  ]

  function handleDropDownClick (e) {
    message.info(e.domEvent.currentTarget.innerText + ' Option Selected')
    if (e.key === '1') {
      setDropBtnName(<IntlMessages id='products.promoadd.include' />)
      setWhichOptionSelect(<IntlMessages id='products.promoadd.exclude' />)
      setIncludeExcludeIdentifier(1)
    } else if (e.key === '2') {
      setDropBtnName(<IntlMessages id='products.promoadd.exclude' />)
      setWhichOptionSelect(<IntlMessages id='products.promoadd.include' />)
      setIncludeExcludeIdentifier(2)
    }
  }

  function handleDropDownClickForReward (e) {
    message.info(e.domEvent.currentTarget.innerText + ' Option Selected')
    if (e.key === '1') {
      setDropBtnNameForReward(<IntlMessages id='products.promoadd.include' />)
      setWhichOptionSelectForReward(
        <IntlMessages id='products.promoadd.exclude' />
      )
      setIncludeExcludeIdentifierForReward(1)
    } else if (e.key === '2') {
      setDropBtnNameForReward(<IntlMessages id='products.promoadd.exclude' />)
      setWhichOptionSelectForReward(
        <IntlMessages id='products.promoadd.include' />
      )
      setIncludeExcludeIdentifierForReward(2)
    }
  }

  function getCardPromoName (evt) {
    setcardPromoName(evt.target.value)
    if (!evt.target.value) {
      setcardPromoName(<IntlMessages id='products.promoadd.promoname' />)
    }
  }

  function getCardPromoDesc (evt) {
    setPromoDescPlace(evt.target.value)
    if (!evt.target.value) {
      setPromoDescPlace(<IntlMessages id='products.promoadd.promodescplace' />)
    }
  }

  function radBtnBasic (evt) {
    setBasicDisCardBtn(evt.target.value)
    if (evt.target.value === 'Percent') {
      setBasicIsPercent(true)
    } else if (evt.target.value === 'Currency') {
      setBasicIsPercent(false)
    }
  }

  function radBtnRewardSave (evt) {
    setRewardSaveBtn(evt.target.value)
    if (evt.target.value === 'Percent') {
      setRewardSaveIsPercent(true)
    } else if (evt.target.value === 'Currency') {
      setRewardSaveIsPercent(false)
    }
  }

  function radBtnRewardDiscount (evt) {
    setRewardDisCardBtn(evt.target.value)
    if (evt.target.value === 'Percent') {
      setIsRewardGetFree(false)
      setIsRewardGetAmount(false)
      setIsRewardGetPercent(true)
    } else if (evt.target.value === 'Currency') {
      setIsRewardGetFree(false)
      setIsRewardGetAmount(true)
      setIsRewardGetPercent(false)
    } else if (evt.target.value === 'Free') {
      setIsRewardGetFree(true)
      setIsRewardGetAmount(false)
      setIsRewardGetPercent(false)
    }
  }

  function radBtnBasicForProd (evt) {
    setBasicDisCardProd(evt.target.value)
    if (evt.target.value === 'All') {
      setBasicIsAll(true)
    } else if (evt.target.value === 'Specific') {
      setBasicIsAll(false)
    }
  }

  //function basicPercentChange(value) {
  //    setBasicDisPerValue(value);
  //}

  //function basicDisAmountChange(value) {
  //    setBasicDisAmountValue(value);
  //}

  //function rewardSaveAmountChange(value) {
  //    setRewardSaveAmountValue(value);
  //}

  //function rewardFixAmountChange(value) {
  //    setRewardFixAmountValue(value);
  //}

  //function rewardSavePercentChange(value) {
  //    setRewardSavePerValue(value);
  //}

  //function rewardGetAmountChange(value) {
  //    setRewardGetAmountValue(value);
  //}

  //function rewardGetpercentChange(value) {
  //    setRewardPercentVal(value);
  //}

  const handleSearchBasicPromoProd = async value => {
    setAutoCompleteError(false)
    setRewardAutoCompleteError(false)
    if (value.length > 1) {
      let nameArray = []
      let searchProd = {
        data: {
          msgCode: '',
          msgDescription: ''
        }
      }
      await ds
        .getBookSearchProd(
          `?keys=${value}&isPromo=true&outletid=${getSelectedOutlet}`
        )
        .then(response => (searchProd.data = response.data))
        .catch(e => {
          if (
            e.response &&
            e.response.status === 401 &&
            checkExpiresSub() > 0
          ) {
            message.error('Token Expired! Redirecting to Login Page')
            setTimeout(() => {
              dispatch(userLogOut(store.getState()))
            }, 3000)
          } else {
            message.error('Check Internet Connection')
          }
        })

      if (searchProd.data.msgCode == 'GENERAL_SUCCESS') {
        if (searchProd.data.data.length > 0) {
          setBasicPromoSearchProd(
            getBasicPromoSearchProd.concat(searchProd.data.data)
          )
          nameArray = searchProd.data.data.map(names => {
            const category = names.productName
            return {
              value: category,
              label: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <span
                    style={{
                      backgroundColor: 'lightcyan',
                      fontStyle: 'oblique',
                      fontWeight: 'bolder'
                    }}
                  >
                    <a>{category}</a>
                  </span>
                  <span>
                    <IntlMessages id='products.addeditpriceprod.searchresult' />
                  </span>
                </div>
              )
            }
          })
        }
        setBasicPromoOptions(nameArray)
      }

      if (searchProd.data.msgCode == 'GENERAL_ERROR') {
        message.error(searchProd.data.msgDescription)
      }
    } else {
      setBasicPromoOptions([])
      setBasicPromoSearchProd([])
    }
  }

  function checkIfExists (array, productID, selObj) {
    let result = false
    const selSearchBy = selObj.entityID ? selObj.entityID : ''
    for (let i = 0; i < array.length; i++) {
      let checkSearchBy = true
      let ifAllowed =
        selSearchBy == PROD_SEARCH_ENTITIES.Search_By_Product ||
        selSearchBy == PROD_SEARCH_ENTITIES.Search_By_SKUs
      if (!ifAllowed) {
        const prodSearchBy = array[i].entityID
        if (prodSearchBy && selSearchBy && selSearchBy != prodSearchBy) {
          checkSearchBy = false
        }
      }
      if (
        getDecryptID(array[i].productID) == productID.toString() &&
        checkSearchBy
      ) {
        result = true
        break
      }
    }
    return result
  }

  //NEW
  const onBasicPromoAddSelect = async selectedObj => {
    let isExist = false
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID =
          isString(selectedObj.productID) && selectedObj.productID.includes('&')
            ? getDecryptID(selectedObj.productID)
            : selectedObj.productID
      }
    } else {
      productID = ''
    }
    isExist = checkIfExists(selectedBasicPromoAdd, productID, selectedObj)
    if (!isExist) {
      if (!StringIsNullOrEmpty(productID)) {
        setSelectedBasicPromoAdd(selectedBasicPromoAdd.concat(selectedObj))
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // // Here we call Details API
        // await ds
        //   .getBookSearchProd(
        //     `?keys=""&isPromo=true&outletid=${getSelectedOutlet}&productID=${productID}`
        //   )
        //   .then(response => {
        //     const productData = response.data
        //     if (productData.msgCode == 'GENERAL_SUCCESS') {
        //       if (productData && productData.data.length > 0) {
        //         newProd = productData.data
        //       }
        //     }
        //     if (productData.msgCode == 'GENERAL_ERROR') {
        //       message.error(productData.msgDescription)
        //     }
        //   })
        //   .catch(e => {
        //     //console.log("Product Search Issue", e)
        //   })
        // if (newProd.length > 0) {
        //   setSelectedBasicPromoAdd(selectedBasicPromoAdd.concat(newProd[0]))
        //   dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // }
      } else {
        message.info('Product not Exist')
      }
    } else {
      message.info('Product Already Exist')
    }
  }
  //OLD
  //  const onBasicPromoAddSelect = (value) => {
  //     let isExist;
  //     for (let i = 0; i < selectedBasicPromoAdd.length; i++) {
  //       if (selectedBasicPromoAdd[i].productName === value) {
  //         isExist = true;
  //         break;
  //       }
  //     }
  //     if (!isExist) {
  //       let supposedArr = getBasicPromoSearchProd.filter(
  //         (a) => a.productName === value
  //       );

  //       setSelectedBasicPromoAdd(selectedBasicPromoAdd.concat(supposedArr[0]));
  //     } else {
  //       message.info("Product Already Exist");
  //     }
  //   };
  //NEW
  const onAdvanceBuyPromoAddSelect = async selectedObj => {
    let isExist
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID =
          isString(selectedObj.productID) && selectedObj.productID.includes('&')
            ? getDecryptID(selectedObj.productID)
            : selectedObj.productID
      }
    } else {
      productID = ''
    }
    isExist = checkIfExists(selectedAdvanceBuyPromoAdd, productID, selectedObj)
    if (!isExist) {
      if (!StringIsNullOrEmpty(productID)) {
        setSelectedAdvanceBuyPromoAdd(
          selectedAdvanceBuyPromoAdd.concat(selectedObj)
        )
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // Here we call Details API
        // await ds
        //   .getBookSearchProd(
        //     `?keys=""&isPromo=true&outletid=${getSelectedOutlet}&productID=${productID}`
        //   )
        //   .then(response => {
        //     const productData = response.data
        //     if (productData.msgCode == 'GENERAL_SUCCESS') {
        //       if (productData && productData.data.length > 0) {
        //         newProd = productData.data
        //       }
        //     }
        //     if (productData.msgCode == 'GENERAL_ERROR') {
        //       message.error(productData.msgDescription)
        //     }
        //   })
        //   .catch(e => console.log('Product Search Issue', e))
        // if (newProd.length > 0) {
        //   setSelectedAdvanceBuyPromoAdd(
        //     selectedAdvanceBuyPromoAdd.concat(newProd[0])
        //   )
        //   dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // }
      } else {
        message.info('Product not Exist')
      }
    } else {
      message.info('Product Already Exist')
    }
  }

  //OLD
  // const onAdvanceBuyPromoAddSelect1 = (value) => {
  //   let isExist;
  //   for (let i = 0; i < selectedAdvanceBuyPromoAdd.length; i++) {
  //     if (selectedAdvanceBuyPromoAdd[i].productName === value) {
  //       isExist = true;
  //       break;
  //     }
  //   }
  //   if (!isExist) {
  //     let supposedArr = getBasicPromoSearchProd.filter(
  //       (a) => a.productName === value
  //     );
  //     setSelectedAdvanceBuyPromoAdd(
  //       selectedAdvanceBuyPromoAdd.concat(supposedArr[0])
  //     );
  //   } else {
  //     message.info("Product Already Exist");
  //   }
  // };

  //NEW
  const onBasicPromoExtraBtnAddSelect = async selectedObj => {
    let isExist
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID =
          isString(selectedObj.productID) && selectedObj.productID.includes('&')
            ? getDecryptID(selectedObj.productID)
            : selectedObj.productID
      }
    } else {
      productID = ''
    }
    isExist = checkIfExists(
      selectedBasicPromoAddExtraBtn,
      productID,
      selectedObj
    )
    if (!isExist) {
      if (!StringIsNullOrEmpty(productID)) {
        setSelectedBasicPromoAddExtraBtn(
          selectedBasicPromoAddExtraBtn.concat(selectedObj)
        )
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // Here we call Details API
        // await ds
        //   .getBookSearchProd(
        //     `?keys=""&isPromo=true&outletid=${getSelectedOutlet}&productID=${productID}`
        //   )
        //   .then(response => {
        //     const productData = response.data
        //     if (productData.msgCode == 'GENERAL_SUCCESS') {
        //       if (productData && productData.data.length > 0) {
        //         newProd = productData.data
        //       }
        //     }
        //     if (productData.msgCode == 'GENERAL_ERROR') {
        //       message.error(productData.msgDescription)
        //     }
        //   })
        //   .catch(e => {
        //     // console.log("Product Search Issue", e)
        //   })
        // if (newProd.length > 0) {
        //   setSelectedBasicPromoAddExtraBtn(
        //     selectedBasicPromoAddExtraBtn.concat(newProd[0])
        //   )
        //   dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // }
      } else {
        message.info('Product not Exist')
      }
    } else {
      message.info('Product Already Exist')
    }
  }
  //OLD
  // const onBasicPromoExtraBtnAddSelect = (value) => {
  //   let isExist;
  //   for (let i = 0; i < selectedBasicPromoAddExtraBtn.length; i++) {
  //     if (selectedBasicPromoAddExtraBtn[i].productName === value) {
  //       isExist = true;
  //       break;
  //     }
  //   }
  //   if (!isExist) {
  //     let supposedArr = getBasicPromoSearchProd.filter(
  //       (a) => a.productName === value
  //     );
  //     setSelectedBasicPromoAddExtraBtn(
  //       selectedBasicPromoAddExtraBtn.concat(supposedArr[0])
  //     );
  //   } else {
  //     message.info("Product Already Exist");
  //   }
  // };

  //NEW
  const onAdvBuyPromoExtraBtnAddSelect = async selectedObj => {
    let isExist
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID =
          isString(selectedObj.productID) && selectedObj.productID.includes('&')
            ? getDecryptID(selectedObj.productID)
            : selectedObj.productID
      }
    } else {
      productID = ''
    }
    isExist = checkIfExists(
      selectedAdvBuyPromoAddExtraBtn,
      productID,
      selectedObj
    )
    if (!isExist) {
      if (!StringIsNullOrEmpty(productID)) {
        setSelectedAdvBuyPromoAddExtraBtn(
          selectedAdvBuyPromoAddExtraBtn.concat(selectedObj)
        )
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // Here we call Details API
        // await ds
        //   .getBookSearchProd(
        //     `?keys=""&isPromo=true&outletid=${getSelectedOutlet}&productID=${productID}`
        //   )
        //   .then(response => {
        //     const productData = response.data
        //     if (productData.msgCode == 'GENERAL_SUCCESS') {
        //       if (productData && productData.data.length > 0) {
        //         newProd = productData.data
        //       }
        //     }
        //     if (productData.msgCode == 'GENERAL_ERROR') {
        //       message.error(productData.msgDescription)
        //     }
        //   })
        //   .catch(e => {
        //     // console.log("Product Search Issue", e)
        //   })
        // if (newProd.length > 0) {
        //   setSelectedAdvBuyPromoAddExtraBtn(
        //     selectedAdvBuyPromoAddExtraBtn.concat(newProd[0])
        //   )
        //   dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // }
      } else {
        message.info('Product not Exist')
      }
    } else {
      message.info('Product Already Exist')
    }
  }
  //OLD
  // const onAdvBuyPromoExtraBtnAddSelect = (value) => {
  //   let isExist;
  //   for (let i = 0; i < selectedAdvBuyPromoAddExtraBtn.length; i++) {
  //     if (selectedAdvBuyPromoAddExtraBtn[i].productName === value) {
  //       isExist = true;
  //       break;
  //     }
  //   }
  //   if (!isExist) {
  //     let supposedArr = getBasicPromoSearchProd.filter(
  //       (a) => a.productName === value
  //     );
  //     setSelectedAdvBuyPromoAddExtraBtn(
  //       selectedAdvBuyPromoAddExtraBtn.concat(supposedArr[0])
  //     );
  //   } else {
  //     message.info("Product Already Exist");
  //   }
  // };

  //NEW
  const onAdvSpendPromoExtraBtnAddSelect = async selectedObj => {
    let isExist
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID =
          isString(selectedObj.productID) && selectedObj.productID.includes('&')
            ? getDecryptID(selectedObj.productID)
            : selectedObj.productID
      }
    } else {
      productID = ''
    }
    isExist = checkIfExists(
      selectedAdvSpendPromoAddExtraBtn,
      productID,
      selectedObj
    )
    if (!isExist) {
      if (!StringIsNullOrEmpty(productID)) {
        setSelectedAdvSpendPromoAddExtraBtn(
          selectedAdvSpendPromoAddExtraBtn.concat(selectedObj)
        )
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // Here we call Details API
        // await ds
        //   .getBookSearchProd(
        //     `?keys=""&isPromo=true&outletid=${getSelectedOutlet}&productID=${productID}`
        //   )
        //   .then(response => {
        //     const productData = response.data
        //     if (productData.msgCode == 'GENERAL_SUCCESS') {
        //       if (productData && productData.data.length > 0) {
        //         newProd = productData.data
        //       }
        //     }
        //     if (productData.msgCode == 'GENERAL_ERROR') {
        //       message.error(productData.msgDescription)
        //     }
        //   })
        //   .catch(e => console.log('Product Search Issue', e))
        // if (newProd.length > 0) {
        //   setSelectedAdvSpendPromoAddExtraBtn(
        //     selectedAdvSpendPromoAddExtraBtn.concat(newProd[0])
        //   )
        //   dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // }
      } else {
        message.info('Product not Exist')
      }
    } else {
      message.info('Product Already Exist')
    }
  }

  //OLD
  // const onAdvSpendPromoExtraBtnAddSelect = (value) => {
  //   let isExist;
  //   for (let i = 0; i < selectedAdvSpendPromoAddExtraBtn.length; i++) {
  //     if (selectedAdvSpendPromoAddExtraBtn[i].productName === value) {
  //       isExist = true;
  //       break;
  //     }
  //   }
  //   if (!isExist) {
  //     let supposedArr = getBasicPromoSearchProd.filter(
  //       (a) => a.productName === value
  //     );
  //     setSelectedAdvSpendPromoAddExtraBtn(
  //       selectedAdvSpendPromoAddExtraBtn.concat(supposedArr[0])
  //     );
  //   } else {
  //     message.info("Product Already Exist");
  //   }
  // };

  //NEW
  const onAdvRewardExtraBtnAddSelect = async selectedObj => {
    let isExist
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID =
          isString(selectedObj.productID) && selectedObj.productID.includes('&')
            ? getDecryptID(selectedObj.productID)
            : selectedObj.productID
      }
    } else {
      productID = ''
    }
    isExist = checkIfExists(
      selectedAdvRewardAddExtraBtn,
      productID,
      selectedObj
    )
    if (!isExist) {
      if (!StringIsNullOrEmpty(productID)) {
        setSelectedAdvRewardAddExtraBtn(
          selectedAdvRewardAddExtraBtn.concat(selectedObj)
        )
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // Here we call Details API
        // await ds
        //   .getBookSearchProd(
        //     `?keys=""&isPromo=true&outletid=${getSelectedOutlet}&productID=${productID}`
        //   )
        //   .then(response => {
        //     const productData = response.data
        //     if (productData.msgCode == 'GENERAL_SUCCESS') {
        //       if (productData && productData.data.length > 0) {
        //         newProd = productData.data
        //       }
        //     }
        //     if (productData.msgCode == 'GENERAL_ERROR') {
        //       message.error(productData.msgDescription)
        //     }
        //   })
        //   .catch(e => {
        //     // console.log("Product Search Issue", e)
        //   })
        // if (newProd.length > 0) {
        //   setSelectedAdvRewardAddExtraBtn(
        //     selectedAdvRewardAddExtraBtn.concat(newProd[0])
        //   )
        //   dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // }
      } else {
        message.info('Product not Exist')
      }
    } else {
      message.info('Product Already Exist')
    }
  }

  //OLD
  // const onAdvRewardExtraBtnAddSelect = (value) => {
  //   let isExist;
  //   for (let i = 0; i < selectedAdvRewardAddExtraBtn.length; i++) {
  //     if (selectedAdvRewardAddExtraBtn[i].productName === value) {
  //       isExist = true;
  //       break;
  //     }
  //   }
  //   if (!isExist) {
  //     let supposedArr = getBasicPromoSearchProd.filter(
  //       (a) => a.productName === value
  //     );
  //     setSelectedAdvRewardAddExtraBtn(
  //       selectedAdvRewardAddExtraBtn.concat(supposedArr[0])
  //     );
  //   } else {
  //     message.info("Product Already Exist");
  //   }
  // };

  //NEW
  const onAdvanceSpendPromoAddSelect = async selectedObj => {
    let isExist
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID =
          isString(selectedObj.productID) && selectedObj.productID.includes('&')
            ? getDecryptID(selectedObj.productID)
            : selectedObj.productID
      }
    } else {
      productID = ''
    }
    isExist = checkIfExists(
      selectedAdvanceSpendPromoAdd,
      productID,
      selectedObj
    )
    if (!isExist) {
      if (!StringIsNullOrEmpty(productID)) {
        setSelectedAdvanceSpendPromoAdd(
          selectedAdvanceSpendPromoAdd.concat(selectedObj)
        )
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // Here we call Details API
        // await ds
        //   .getBookSearchProd(
        //     `?keys=""&isPromo=true&outletid=${getSelectedOutlet}&productID=${productID}`
        //   )
        //   .then(response => {
        //     const productData = response.data
        //     if (productData.msgCode == 'GENERAL_SUCCESS') {
        //       if (productData && productData.data.length > 0) {
        //         newProd = productData.data
        //       }
        //     }
        //     if (productData.msgCode == 'GENERAL_ERROR') {
        //       message.error(productData.msgDescription)
        //     }
        //   })
        //   .catch(e => {
        //     // console.log("Product Search Issue", e)
        //   })
        // if (newProd.length > 0) {
        //   setSelectedAdvanceSpendPromoAdd(
        //     selectedAdvanceSpendPromoAdd.concat(newProd[0])
        //   )
        //   dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // }
      } else {
        message.info('Product not Exist')
      }
    } else {
      message.info('Product Already Exist')
    }
  }

  //OLD
  // const onAdvanceSpendPromoAddSelect = (value) => {
  //   setAutoCompleteError(false);
  //   setRewardAutoCompleteError(false);
  //   let isExist;
  //   for (let i = 0; i < selectedAdvanceSpendPromoAdd.length; i++) {
  //     if (selectedAdvanceSpendPromoAdd[i].productName === value) {
  //       isExist = true;
  //       break;
  //     }
  //   }
  //   if (!isExist) {
  //     let supposedArr = getBasicPromoSearchProd.filter(
  //       (a) => a.productName === value
  //     );
  //     setSelectedAdvanceSpendPromoAdd(
  //       selectedAdvanceSpendPromoAdd.concat(supposedArr[0])
  //     );
  //   } else {
  //     message.info("Product Already Exist");
  //   }
  // };

  //NEW
  const onRewardAddSelect = async selectedObj => {
    let isExist
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID =
          isString(selectedObj.productID) && selectedObj.productID.includes('&')
            ? getDecryptID(selectedObj.productID)
            : selectedObj.productID
      }
    } else {
      productID = ''
    }
    isExist = checkIfExists(selectedAdvanceRewardAdd, productID, selectedObj)
    if (!isExist) {
      if (!StringIsNullOrEmpty(productID)) {
        setSelectedAdvanceRewardAdd(
          selectedAdvanceRewardAdd.concat(selectedObj)
        )
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // Here we call Details API
        // await ds
        //   .getBookSearchProd(
        //     `?keys=""&isPromo=true&outletid=${getSelectedOutlet}&productID=${productID}`
        //   )
        //   .then(response => {
        //     const productData = response.data
        //     if (productData.msgCode == 'GENERAL_SUCCESS') {
        //       if (productData && productData.data.length > 0) {
        //         newProd = productData.data
        //       }
        //     }
        //     if (productData.msgCode == 'GENERAL_ERROR') {
        //       message.error(productData.msgDescription)
        //     }
        //   })
        //   .catch(e => {
        //     // console.log("Product Search Issue", e)
        //   })
        // if (newProd.length > 0) {
        //   setSelectedAdvanceRewardAdd(
        //     selectedAdvanceRewardAdd.concat(newProd[0])
        //   )
        //   dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        // }
      } else {
        message.info('Product not Exist')
      }
    } else {
      message.info('Product Already Exist')
    }
  }

  //OLD
  // const onRewardAddSelect = (value) => {
  //   let isExist;
  //   for (let i = 0; i < selectedAdvanceRewardAdd.length; i++) {
  //     if (selectedAdvanceRewardAdd[i].productName === value) {
  //       isExist = true;
  //       break;
  //     }
  //   }
  //   if (!isExist) {
  //     let supposedArr = getBasicPromoSearchProd.filter(
  //       (a) => a.productName === value
  //     );
  //     setSelectedAdvanceRewardAdd(
  //       selectedAdvanceRewardAdd.concat(supposedArr[0])
  //     );
  //   } else {
  //     message.info("Product Already Exist");
  //   }
  // };

  function extraIncludeExcludeBtn () {
    setIsExclude(true)
    //if (getIsExclude) {
    //    setIsExclude(false);
    //    setSelectedBasicPromoAddExtraBtn([]);
    //}
    //else if (!getIsExclude) {
    //    setIsExclude(true);
    //}
  }

  function advBuyextraIncludeExcludeBtn () {
    setAdvanceBuyIsExclude(true)

    //if (getAdvanceBuyIsExclude) {
    //    setAdvanceBuyIsExclude(false);
    //    setSelectedBasicPromoAddExtraBtn([]);
    //}
    //else if (!getAdvanceBuyIsExclude) {
    //    setAdvanceBuyIsExclude(true);
    //}
  }

  function whenCusSelected (key) {
    setIsReward(true)
    if (key === 1) {
      setIsWhenCusSpend(false)
      setIsWhenCusBuy(true)
      setWhenCusDropValue(<IntlMessages id='products.promoadd.whencus1' />)
      setIdentifyWhenCusDropDownSelection(1)
    } else if (key === 2) {
      setIsWhenCusBuy(false)
      setIsWhenCusSpend(true)
      setWhenCusDropValue(<IntlMessages id='products.promoadd.whencus2' />)
      setIdentifyWhenCusDropDownSelection(2)
    }
  }

  //function advanceQuantityChange(value) {
  //    setAdvBuyItemQuantity(value);
  //}

  //function advanceRewardGetQuantityChange(value) {
  //    setAdvRewardGetQuantityQuantity(value);
  //}

  //function advanceRewardGetFreeQuantityChange(value) {
  //    setAdvRewardGetFreeQuantity(value);
  //}

  //function advanceGetRewardPercentQuantityChange(value) {
  //    setAdvRewardGetItemQuantity(value);
  //}

  //function advanceAmountChange(value) {
  //    setAdvSpendAmount(value);
  //}

  function radBtnAdvanceBuyForProd (evt) {
    setAdvanceBuyCardProd(evt.target.value)
    if (evt.target.value === 'All') {
      setAdvanceBuyIsAll(true)
    } else if (evt.target.value === 'Specific') {
      setAdvanceBuyIsAll(false)
    }
  }

  function radBtnAdvanceRewardForProd (evt) {
    setAdvanceRewardCardProd(evt.target.value)
    if (evt.target.value === 'All') {
      setAdvanceRewardIsAll(true)
    } else if (evt.target.value === 'Specific') {
      setAdvanceRewardIsAll(false)
    }
    //setAdvanceRewardIsAll
  }

  function radBtnAdvanceSpendForProd (evt) {
    setAdvanceSpendCardProd(evt.target.value)
    if (evt.target.value === 'All') {
      setAdvanceSpendIsAll(true)
    } else if (evt.target.value === 'Specific') {
      setAdvanceSpendIsAll(false)
    }
  }

  function checkBox (e) {
    if (e.target.checked) {
      setIsShowPromptOnSellScreen(true)
    } else {
      setIsShowPromptOnSellScreen(false)
    }
  }

  function exclusiveRadioBtn (evt) {
    if (evt.target.value === 1) {
      setExclusiveCusValue(1)
    } else if (evt.target.value === 2) {
      setExclusiveCusValue(2)
    }
  }

  function basicDisTagClose (e) {
    let supposedArr = selectedBasicPromoAdd.filter(a => a.productName !== e)
    setSelectedBasicPromoAdd(supposedArr)
    if (supposedArr.length < 1) {
      setIsExclude(false)
      setSelectedBasicPromoAddExtraBtn([])
    }
    // setDeSelectedPromoProd(e);
    setDeSelectedPromoProd(getDeSelectedPromoProd.concat(e))
  }

  function advanceBuyTagClose (e) {
    let supposedArr = selectedAdvanceBuyPromoAdd.filter(
      a => a.productName !== e
    )
    setSelectedAdvanceBuyPromoAdd(
      selectedAdvanceBuyPromoAdd.filter(a => a.productName !== e)
    )
    if (supposedArr.length < 1) {
      setAdvanceBuyIsExclude(false)
      setSelectedAdvBuyPromoAddExtraBtn([])
    }
    setDeSelectedPromoProd(getDeSelectedPromoProd.concat(e))
  }

  function advanceSpendTagClose (e) {
    let supposedArr = selectedAdvanceSpendPromoAdd.filter(
      a => a.productName !== e
    )
    setSelectedAdvanceSpendPromoAdd(
      selectedAdvanceSpendPromoAdd.filter(a => a.productName !== e)
    )
    if (supposedArr.length < 1) {
      setAdvanceSpendIsExclude(false)
      setSelectedAdvSpendPromoAddExtraBtn([])
    }
    setDeSelectedPromoProd(getDeSelectedPromoProd.concat(e))
  }

  function advanceRewardTagClose (e) {
    let supposedArr = selectedAdvanceRewardAdd.filter(a => a.productName !== e)
    setSelectedAdvanceRewardAdd(
      selectedAdvanceRewardAdd.filter(a => a.productName !== e)
    )
    if (supposedArr.length < 1) {
      setAdvanceRewardIsExclude(false)
      setSelectedAdvRewardAddExtraBtn([])
    }
    setDeSelectedRewardProd(getDeSelectedPromoProd.concat(e))
  }

  function basicDisTagCloseExtraBtn (e) {
    setSelectedBasicPromoAddExtraBtn(
      selectedBasicPromoAddExtraBtn.filter(a => a.productName !== e)
    )
    setDeSelectedPromoProd(getDeSelectedPromoProd.concat(e))
  }

  function advBuyTagCloseExtraBtn (e) {
    let supposedArr = selectedAdvBuyPromoAddExtraBtn
    supposedArr = supposedArr.filter(a => a.productName !== e)
    setSelectedAdvBuyPromoAddExtraBtn(supposedArr)
    setDeSelectedPromoProd(getDeSelectedPromoProd.concat(e))
  }

  function advSpendTagCloseExtraBtn (e) {
    let supposedArr = selectedAdvSpendPromoAddExtraBtn
    supposedArr = supposedArr.filter(a => a.productName !== e)
    setSelectedAdvSpendPromoAddExtraBtn(supposedArr)
    setDeSelectedPromoProd(getDeSelectedPromoProd.concat(e))
  }

  function advRewardTagCloseExtraBtn (e) {
    let supposedArr = selectedAdvRewardAddExtraBtn
    supposedArr = supposedArr.filter(a => a.productName != e)
    setSelectedAdvRewardAddExtraBtn(supposedArr)
    setDeSelectedRewardProd(getDeSelectedPromoProd.concat(e)) //NOTE: to remove item check this in concat getDeSelectedRewardProd
  }

  function advSpendextraIncludeExcludeBtn () {
    setAdvanceSpendIsExclude(true)

    //if (getAdvanceSpendIsExclude) {
    //    setAdvanceSpendIsExclude(false);
    //    setSelectedBasicPromoAddExtraBtn([]);
    //}
    //else if (!getAdvanceSpendIsExclude) {
    //    setAdvanceSpendIsExclude(true);
    //}
  }

  function advRewardEextraIncludeExcludeBtn () {
    setAdvanceRewardIsExclude(true)

    //if (getAdvanceRewardIsExclude) {
    //    setAdvanceRewardIsExclude(false);
    //    setSelectedAdvanceRewardAdd([]);
    //}
    //else if (!getAdvanceRewardIsExclude) {
    //    setAdvanceRewardIsExclude(true);
    //}
  }

  function whenRewardSelected (key, value) {
    //setRewardDropValue(value.children);
    if (value.children.includes('Get')) {
      setIsRewardGetKind(true)
      setIsRewardFixed(false)
      setIsRewardSave(false)
    } else if (value.children.includes('Save')) {
      setIsRewardGetKind(false)
      setIsRewardFixed(false)
      setIsRewardSave(true)
    } else if (value.children.includes('Pay')) {
      setIsRewardGetKind(false)
      setIsRewardFixed(true)
      setIsRewardSave(false)
    }
  }

  function BasicExtraBtnDelIcon () {
    setIsExclude(false)
    let supposedArr = selectedBasicPromoAddExtraBtn
    if (supposedArr && supposedArr.length && supposedArr.length > 0) {
      let deSelectedNames = supposedArr.map(a => a.productName)
      setDeSelectedPromoProd(getDeSelectedPromoProd.concat(deSelectedNames))
    }
    setSelectedBasicPromoAddExtraBtn([])
  }

  function AdvBuyExtraBtnDelIcon () {
    setAdvanceBuyIsExclude(false)
    let supposedArr = selectedAdvBuyPromoAddExtraBtn
    if (supposedArr && supposedArr.length && supposedArr.length > 0) {
      let deSelectedNames = supposedArr.map(a => a.productName)
      setDeSelectedPromoProd(getDeSelectedPromoProd.concat(deSelectedNames))
    }
    setSelectedAdvBuyPromoAddExtraBtn([])
  }

  function AdvSpendExtraBtnDelIcon () {
    setAdvanceSpendIsExclude(false)
    let supposedArr = selectedAdvSpendPromoAddExtraBtn
    if (supposedArr && supposedArr.length && supposedArr.length > 0) {
      let deSelectedNames = supposedArr.map(a => a.productName)
      setDeSelectedPromoProd(getDeSelectedPromoProd.concat(deSelectedNames))
    }
    setSelectedAdvSpendPromoAddExtraBtn([])
  }

  function AdvRewardExtraBtnDelIcon () {
    setAdvanceRewardIsExclude(false)
    let supposedArr = selectedAdvRewardAddExtraBtn
    if (supposedArr && supposedArr.length && supposedArr.length > 0) {
      let deSelectedNames = supposedArr.map(a => a.productName)
      setDeSelectedPromoProd(getDeSelectedPromoProd.concat(deSelectedNames))
    }
    setSelectedAdvRewardAddExtraBtn([])
  }

  function extractPromoProdNeeds (searchBy, objEntityID) {
    let entityID = 0
    if (!searchBy) {
      switch (objEntityID && parseInt(objEntityID)) {
        case PROD_SEARCH_ENTITIES.Search_By_Category: {
          entityID = PROD_SEARCH_ENTITIES.Search_By_Category
          break
        }
        case PROD_SEARCH_ENTITIES.Search_By_Brand: {
          entityID = PROD_SEARCH_ENTITIES.Search_By_Brand
          break
        }
        case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
          entityID = PROD_SEARCH_ENTITIES.Search_By_Supplier
          break
        }
        case PROD_SEARCH_ENTITIES.Search_By_Tags: {
          entityID = PROD_SEARCH_ENTITIES.Search_By_Tags
          break
        }
        default: {
          break
        }
      }
    }
    return entityID
  }

  const onFinish = values => {
    setIsSpinning(true)
    try {
      let methType = BEHAVIOUR_TYPE.POST
      let startDate = undefined
      let endDate = undefined
      if (radioDatePick == 1) {
        startDate =
          values.formDate !== undefined
            ? values.formDate[0].format('DD/MM/YYYY HH:mm')
            : undefined

        endDate =
          values.formDate !== undefined
            ? values.formDate[1].format('DD/MM/YYYY HH:mm')
            : undefined
      } else {
        startDate =
          values.timeRange !== undefined
            ? moment(values.timeRange[0], 'DD/MM/YYYY HH:mm')
                .add(additionalYears, 'years')
                .format('DD/MM/YYYY HH:mm')
            : undefined
        endDate =
          values.timeRange !== undefined
            ? moment(values.timeRange[1], 'DD/MM/YYYY HH:mm')
                .add(additionalYears, 'years')
                .format('DD/MM/YYYY HH:mm')
            : undefined
      }
      let outlets =
        values.outlets &&
        values.outlets.length > 0 &&
        values.outlets.map(e => {
          return {
            OutletID_SID: getOutletsData.filter(a => a.name === e)[0].id,
            OutletName: getOutletsData.filter(a => a.name === e)[0].name
          }
        })
      let customers =
        values.customers &&
        values.customers.length > 0 &&
        values.customers.map(e => {
          return {
            CustomerID_SID: getCustomersData.filter(a => a.name === e)[0].id,
            CustomerGroupName: getCustomersData.filter(a => a.name === e)[0]
              .name
          }
        })

      if (getIsEveryone) {
        customers = [
          {
            CustomerID_SID: '0&&_a9ce-a98d-4ac1-bc95-a952835b5899',
            CustomerGroupName: 'All Customer Groups'
          }
        ]
      }

      //for products
      let basicPromoProd = []
      basicPromoProd =
        selectedBasicPromoAdd &&
        selectedBasicPromoAdd.map(e => {
          const searchBy =
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_Product ||
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_SKUs
          let entityID = !searchBy ? e.entityID : 0 // extractPromoProdNeeds(searchBy, e.entityID)
          if (e.productID) {
            return {
              EntityID: !searchBy && entityID ? entityID : 0,
              RowID:
                !searchBy && entityID && e.productID
                  ? parseInt(getDecryptID(e.productID))
                  : 0,
              ProductID: searchBy
                ? isString(e.productID)
                  ? e.productID
                  : `${e.productID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
                : '',
              IsInclude: getIncludeExcludeIdentifier === 1 ? true : false,
              IsExclude: getIncludeExcludeIdentifier === 2 ? true : false
            }
          }
        })
      let basicExtraBtnPromoProd =
        selectedBasicPromoAddExtraBtn &&
        selectedBasicPromoAddExtraBtn.map(e => {
          const searchBy =
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_Product ||
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_SKUs
          let entityID = !searchBy ? e.entityID : 0 // extractPromoProdNeeds(searchBy, e.entityID)
          if (e.productID) {
            return {
              EntityID: !searchBy && entityID ? entityID : 0,
              RowID:
                !searchBy && entityID && e.productID
                  ? parseInt(getDecryptID(e.productID))
                  : 0,
              ProductID: searchBy ? e.productID : '',
              IsInclude: getIncludeExcludeIdentifier === 2 ? true : false,
              IsExclude: getIncludeExcludeIdentifier === 1 ? true : false
            }
          }
        })
      basicPromoProd = basicPromoProd.concat(basicExtraBtnPromoProd)

      let advanceBuyPromoProd = []
      advanceBuyPromoProd =
        selectedAdvanceBuyPromoAdd &&
        selectedAdvanceBuyPromoAdd.map(e => {
          const searchBy =
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_Product ||
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_SKUs
          let entityID = !searchBy ? e.entityID : 0 // extractPromoProdNeeds(searchBy, e.entityID)
          if (e.productID) {
            return {
              EntityID: !searchBy && entityID ? entityID : 0,
              RowID:
                !searchBy && entityID && e.productID
                  ? parseInt(getDecryptID(e.productID))
                  : 0,
              ProductID: searchBy ? e.productID : '',
              IsInclude: getIncludeExcludeIdentifier === 1 ? true : false,
              IsExclude: getIncludeExcludeIdentifier === 2 ? true : false
            }
          }
        })
      let advanceBuyExtraBtnPromoProd =
        selectedAdvBuyPromoAddExtraBtn &&
        selectedAdvBuyPromoAddExtraBtn.map(e => {
          const searchBy =
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_Product ||
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_SKUs
          let entityID = !searchBy ? e.entityID : 0 // extractPromoProdNeeds(searchBy, e.entityID)
          if (e.productID) {
            return {
              EntityID: !searchBy && entityID ? entityID : 0,
              RowID:
                !searchBy && entityID && e.productID
                  ? parseInt(getDecryptID(e.productID))
                  : 0,
              ProductID: searchBy ? e.productID : '',
              IsInclude: getIncludeExcludeIdentifier === 2 ? true : false,
              IsExclude: getIncludeExcludeIdentifier === 1 ? true : false
            }
          }
        })
      advanceBuyPromoProd = advanceBuyPromoProd.concat(
        advanceBuyExtraBtnPromoProd
      )

      let advanceSpendPromoProd = []
      advanceSpendPromoProd =
        selectedAdvanceSpendPromoAdd &&
        selectedAdvanceSpendPromoAdd.map(e => {
          const searchBy =
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_Product ||
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_SKUs
          let entityID = !searchBy ? e.entityID : 0 // extractPromoProdNeeds(searchBy, e.entityID)
          if (e.productID) {
            return {
              EntityID: !searchBy && entityID ? entityID : 0,
              RowID:
                !searchBy && entityID && e.productID
                  ? parseInt(getDecryptID(e.productID))
                  : 0,
              ProductID: searchBy ? e.productID : '',
              IsInclude: getIncludeExcludeIdentifier === 1 ? true : false,
              IsExclude: getIncludeExcludeIdentifier === 2 ? true : false
            }
          }
        })
      let advanceSpendExtraBtnPromoProd =
        selectedAdvSpendPromoAddExtraBtn &&
        selectedAdvSpendPromoAddExtraBtn.map(e => {
          const searchBy =
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_Product ||
            e.entityID == PROD_SEARCH_ENTITIES.Search_By_SKUs
          let entityID = !searchBy ? e.entityID : 0 // extractPromoProdNeeds(searchBy, e.entityID)
          if (e.productID) {
            return {
              EntityID: !searchBy && entityID ? entityID : 0,
              RowID:
                !searchBy && entityID && e.productID
                  ? parseInt(getDecryptID(e.productID))
                  : 0,
              ProductID: searchBy ? e.productID : '',
              IsInclude: getIncludeExcludeIdentifier === 2 ? true : false,
              IsExclude: getIncludeExcludeIdentifier === 1 ? true : false
            }
          }
        })
      advanceSpendPromoProd = advanceSpendPromoProd.concat(
        advanceSpendExtraBtnPromoProd
      )

      let advanceRewardPromoProd = []
      advanceRewardPromoProd =
        selectedAdvanceRewardAdd &&
        selectedAdvanceRewardAdd.map(e => {
          return {
            ProductID: isString(e.productID)
              ? e.productID
              : `${e.productID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
            IsInclude:
              getIncludeExcludeIdentifierForReward === 1 ? true : false,
            IsExclude: getIncludeExcludeIdentifierForReward === 2 ? true : false
          }
        })
      let advanceRewardExtraBtnPromoProd =
        selectedAdvRewardAddExtraBtn &&
        selectedAdvRewardAddExtraBtn.map(e => {
          return {
            ProductID: isString(e.productID)
              ? e.productID
              : `${e.productID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
            IsInclude:
              getIncludeExcludeIdentifierForReward === 2 ? true : false,
            IsExclude: getIncludeExcludeIdentifierForReward === 1 ? true : false
          }
        })
      advanceRewardPromoProd = advanceRewardPromoProd.concat(
        advanceRewardExtraBtnPromoProd
      )

      //products specific -> product check
      // if (!getBasicIsAll || !getAdvanceBuyIsAll || !getAdvanceSpendIsAll) {
      if (
        (!getIsAdvance && !getBasicIsAll) ||
        (getIsAdvance && !getAdvanceBuyIsAll) ||
        (getIsAdvance && !getAdvanceSpendIsAll)
      ) {
        let checkPromoProducts = getIsBasic
          ? basicPromoProd
          : getIsAdvance && getIsWhenCusBuy && !getAdvanceBuyIsAll
          ? advanceBuyPromoProd
          : getIsAdvance && getIsWhenCusSpend && !getAdvanceSpendIsAll
          ? advanceSpendPromoProd
          : []

        if (
          (checkPromoProducts &&
            !checkPromoProducts.length &&
            checkPromoProducts.length < 1) ||
          checkPromoProducts == undefined
        ) {
          setIsSpinning(false)
          setAutoCompleteError(true)
          message.error('Kindly Select Some Specific Product or Select All ...')
          return
        }
      }
      if (getIsAdvance && getIsRewardGetKind && !getAdvanceRewardIsAll) {
        if (
          (advanceRewardPromoProd &&
            !advanceRewardPromoProd.length &&
            advanceRewardPromoProd.length < 1) ||
          advanceRewardPromoProd == undefined
        ) {
          setIsSpinning(false)
          setRewardAutoCompleteError(true)
          message.error(
            'Kindly Select Some Product for REWARD or Select All ...'
          )
          return
        }
      }

      // for reward
      let rewardSpecifications = {
        DiscountPercent:
          getIsAdvance && getIsRewardGetKind && getIsRewardGetPercent
            ? values.rewGetPercent
            : 0,
        DiscountAmount:
          getIsAdvance && getIsRewardGetKind && getIsRewardGetAmount
            ? values.rewGetAmount
            : 0,
        IsFree:
          getIsAdvance && getIsRewardGetKind && getIsRewardGetFree
            ? getIsRewardGetFree
            : false,
        SavePercent:
          getIsAdvance && getIsRewardSave && getRewardSaveIsPercent
            ? values.rewSavePercent
            : 0,
        SaveAmount:
          getIsAdvance && getIsRewardSave && !getRewardSaveIsPercent
            ? values.rewSaveAmount
            : 0,
        IsSavePercent:
          getIsAdvance && getIsRewardSave && getRewardSaveIsPercent
            ? getRewardSaveIsPercent
            : false,
        IsSaveAmount:
          getIsAdvance && getIsRewardSave && !getRewardSaveIsPercent
            ? true
            : false,
        Quantity:
          getIsAdvance && getIsRewardGetKind && getIsRewardGetPercent
            ? values.rewGetDiscount
            : getIsAdvance && getIsRewardGetKind && getIsRewardGetFree
            ? values.rewGetFree
            : getIsAdvance && getIsRewardGetKind && getIsRewardGetAmount
            ? values.rewGetAmountDis
            : 0,
        FixedPriceAmount:
          getIsAdvance && getIsRewardFixed ? values.rewFixAmount : 0,
        IsGetItems:
          getIsAdvance && getIsReward && getIsRewardGetKind
            ? getIsRewardGetKind
            : false,
        IsSave:
          getIsAdvance && getIsReward && getIsRewardSave
            ? getIsRewardSave
            : false,
        IsFixPay:
          getIsAdvance && getIsReward && getIsRewardSave
            ? getIsRewardSave
            : false
      }
      let postBody = {
        PromoName: values.promoName,
        PromoDesc: values.description,
        RewardID: values.rewards ? values.rewards[1] : undefined,
        StartDate: startDate,
        EndDate: endDate,
        Day:
          radioDatePick == 2 && values.daySelection ? values.daySelection : '',

        IsBasic: getIsBasic,
        IsAdvance: getIsAdvance,
        IsBuy: getIsWhenCusBuy,
        IsSpend: getIsWhenCusSpend,
        IsDiscountPercent: getIsBasic ? getBasicIsPercent : false,
        IsDiscountAmount: getIsBasic && !getBasicIsPercent ? true : false,
        IsSpecificProduct: !getBasicIsAll ? true : false,
        IsRewardSpecificProduct:
          getIsAdvance && getIsReward && !getAdvanceRewardIsAll ? true : false,
        IsAvailableToEveryone: selectedCus == 2 ? false : getIsEveryone,
        IsAllProducts: getIsBasic
          ? getBasicIsAll
          : getIsAdvance && getIsWhenCusBuy
          ? getAdvanceBuyIsAll
          : getIsAdvance && getIsWhenCusSpend
          ? getAdvanceSpendIsAll
          : false,
        IsAllRewardProducts:
          getIsAdvance && getIsReward && getIsRewardGetKind
            ? getAdvanceRewardIsAll
            : false,

        BasicDiscountAmount:
          getIsBasic && !getBasicIsPercent ? values.disCurrency : 0,
        BasicDiscountPercent:
          getIsBasic && getBasicIsPercent ? values.disPercent : 0,
        AdvanceBuyItemsQuantity:
          getIsAdvance && getIsWhenCusBuy ? values.advBuyQuantity : 0,
        AdvanceSpendAmount:
          getIsAdvance && getIsWhenCusSpend ? values.advSpendAmount : 0,
        IsShowPromptSell: getIsAdvance ? getIsShowPromptOnSellScreen : false,

        PromoProducts: getIsBasic
          ? basicPromoProd
          : getIsAdvance && getIsWhenCusBuy && !getAdvanceBuyIsAll
          ? advanceBuyPromoProd
          : getIsAdvance && getIsWhenCusSpend && !getAdvanceSpendIsAll
          ? advanceSpendPromoProd
          : [],
        PromoOutlets: outlets,
        PromoCustomers: getExclusiveCusValue == 2 ? [] : customers,
        RewardProducts:
          getIsAdvance && getIsRewardGetKind && !getAdvanceRewardIsAll
            ? advanceRewardPromoProd
            : [],
        RewardSpecifications:
          getIsAdvance && getIsReward ? rewardSpecifications : {},
        PromoCodes: getExclusiveCusValue == 2 ? getReduxPromoCodes : [],
        IsPromoCodes: getExclusiveCusValue == 2 ? true : false
      }

      //for edit duplicate scenario
      if (promoID) {
        //if outlet would need to remove
        getOutletsDeSelect &&
          getOutletsDeSelect.length > 0 &&
          getOutletsDeSelect.map(e => {
            let supposedObj
            let isExist =
              outlets &&
              outlets.length > 0 &&
              outlets.filter(a => a.OutletName === e)
            if (!isExist.length) {
              if (getUserOutlets && getUserOutlets.length > 0) {
                let isUserOutExist = getUserOutlets.filter(
                  b => b.outletName === e
                )
                if (isUserOutExist.length > 0) {
                  supposedObj = {
                    OutletID_SID: getUserOutlets.filter(
                      b => b.outletName === e
                    )[0].outletID_SID,
                    OutletName: getUserOutlets.filter(
                      b => b.outletName === e
                    )[0].outletName,
                    IsRemove: true,
                    PromoOutletID: getUserOutlets.filter(
                      b => b.outletName === e
                    )[0].promoOutletID
                  }
                  outlets.push(supposedObj)
                }
              }
            }
          })

        //if customer groups would need to remove
        if (!getIsEveryone) {
          getCusGroupsDeSelect &&
            getCusGroupsDeSelect.length > 0 &&
            getCusGroupsDeSelect.map(e => {
              let supposedObj
              let isExist =
                customers &&
                customers.length > 0 &&
                customers.filter(a => a.CustomerGroupName === e)
              if (!isExist.length) {
                if (getUserCusGroups && getUserCusGroups.length > 0) {
                  let isUserCusExist = getUserCusGroups.filter(
                    b => b.customerGroupName === e
                  )
                  if (isUserCusExist.length > 0) {
                    supposedObj = {
                      CustomerID_SID: getUserCusGroups.filter(
                        b => b.customerGroupName === e
                      )[0].customerID_SID,
                      CustomerGroupName: getUserCusGroups.filter(
                        b => b.customerGroupName === e
                      )[0].customerGroupName,
                      IsRemove: true,
                      PromoCustomerID: getUserCusGroups.filter(
                        b => b.customerGroupName === e
                      )[0].promoCustomerID
                    }
                    customers.push(supposedObj)
                  }
                }
              }
            })
        }

        //if promo products would need to remove
        let supposedPromoProd = postBody.PromoProducts
        getDeSelectedPromoProd &&
          getDeSelectedPromoProd.length > 0 &&
          getDeSelectedPromoProd.map(e => {
            let supposedObj
            let isExist =
              supposedPromoProd &&
              supposedPromoProd.length > 0 &&
              supposedPromoProd.filter(a => a.ProductName === e)
            if (!isExist.length) {
              if (getUserPromoProd && getUserPromoProd.length > 0) {
                let isUserPromoProdExist = getUserPromoProd.filter(
                  b => b.productName === e
                )
                if (isUserPromoProdExist.length > 0) {
                  supposedObj = {
                    ProductID: getUserPromoProd.filter(
                      b => b.productName === e
                    )[0].productID,
                    PromoProductID: getUserPromoProd.filter(
                      b => b.productName === e
                    )[0].promotionProductID,
                    IsInclude: getUserPromoProd.filter(
                      b => b.productName === e
                    )[0].isInclude,
                    IsExclude: getUserPromoProd.filter(
                      b => b.productName === e
                    )[0].isExclude,
                    IsRemove: true
                  }
                  supposedPromoProd.push(supposedObj)
                }
              }
            }
          })

        postBody.PromotionID = match.path.includes('duplicate') ? '' : promoID
        postBody.IsEdit = match.path.includes('duplicate') ? false : true
        postBody.BehaviorName = match.path.includes('duplicate') ? 1 : 3

        postBody.PromoOutlets = outlets
        postBody.PromoCustomers = customers
        postBody.PromoProducts = supposedPromoProd
        methType = match.path.includes('duplicate')
          ? BEHAVIOUR_TYPE.POST
          : BEHAVIOUR_TYPE.UPDATE
      }

      postPromotion(postBody, methType, PkgFeatures.Promotions)
    } catch (e) {
      setIsSpinning(false)
      message.warn('Connection broke...')
    }
  }

  const onFinishFailed = errorInfo => {
    setIsSpinning(false)
    message.error('Kindly Attend to Missing Fields')
  }

  function handleCancel () {
    dispatch(loadPromoCodesModal(false))
    // setIsPromoCodeVisible(false);
  }

  function onDatePickChange (e) {
    setRadioDatePick(e.target.value)
  }

  return getIsAllowRead && isFeatureAllowed ? (
    <div className='Content-wrapper NewPromotion-pg'>
      <Spin
        tip={<IntlMessages id='products.promoadd.loadpromo' />}
        spinning={getIsSpinning}
        size='large'
      >
        <div className='back-arrow-h1'>
          <h1 className='d-flex align-items-center'>
            <ArrowLeftOutlined
              className='dk-vertical-align'
              onClick={() => history.push('/Dashboard/products/promotions')}
            />
            <span className='mx-2'>
              {' '}
              {promoID ? (
                form.getFieldValue('promoName')
              ) : (
                <IntlMessages id='products.promoadd.addpromo' />
              )}
            </span>
          </h1>
        </div>

        <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
          <Col lg={18} md={12} sm={14} xs={24}>
            <p className='title vd-hero-intro custom-font-color-black m-0'>
              <IntlMessages id='products.promoadd.createnewprmo' />
            </p>
          </Col>
          <Col lg={6} md={12} sm={10} xs={24}>
            <div className='pg-header-btn'>
              <Button
                className='dk-btn-cancel dk-wd-auto'
                type='primary'
                onClick={() => {
                  history.push('/Dashboard/products/promotions')
                }}
                size='large'
              >
                <IntlMessages id='products.promoadd.canbtn' />
              </Button>
              {promoID ? (
                <>
                  {!getIsDisableUpdate && (
                    <Button
                      className='dk-btn-add dk-wd-auto'
                      form='promoForm'
                      htmlType='submit'
                      type='primary'
                      size='large'
                    >
                      <IntlMessages id='products.promoadd.savbtn' />
                    </Button>
                  )}
                </>
              ) : (
                <>
                  {!getIsDisableCreate && (
                    <Button
                      className='dk-btn-add dk-wd-auto'
                      form='promoForm'
                      htmlType='submit'
                      type='primary'
                      size='large'
                    >
                      <IntlMessages id='products.promoadd.savbtn' />
                    </Button>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>

        <div className='custom-mg-top-25'>
          <Row>
            <Col lg={6} md={24} sm={24} xs={24}>
              <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                <IntlMessages id='products.promoadd.general' />
              </h2>
              <p className='dk-font-size-15'>
                <IntlMessages id='products.promoadd.genbrief' />
              </p>
            </Col>

            <Col lg={9} md={12} sm={24} xs={24}>
              <Form
                {...formItemLayout}
                form={form}
                name='promoForm'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                scrollToFirstError
              >
                <InputGroup size='large' className='ant-row-FlexFix'>
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-custom-alignment form-inner-pad-0'
                    name='promoName'
                    label={<IntlMessages id='products.promoadd.promoname' />}
                    rules={[
                      {
                        required: true,
                        message: (
                          <IntlMessages id='products.promoadd.promoname' />
                        )
                      },
                      {
                        max: 30,
                        message: <IntlMessages id='products.promoadd.only30' />
                      }
                    ]}
                  >
                    <Input
                      placeholder='Promotion Name'
                      className='custom-promoadd-inputnamepro'
                      onChange={getCardPromoName}
                    />
                  </Form.Item>
                </InputGroup>

                <p className='font-size-smaller'>
                  <IntlMessages id='products.promoadd.maxchar' />
                </p>

                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0'
                  name='description'
                  label={<IntlMessages id='products.promoadd.promodesc' />}
                  rules={[
                    {
                      max: 70,
                      message: <IntlMessages id='products.promoadd.only70' />
                    }
                  ]}
                >
                  <Input.TextArea
                    placeholder='Provide a short description to explain this promotion.'
                    style={{ height: '100px' }}
                    onChange={getCardPromoDesc}
                  />
                </Form.Item>

                <p className='font-size-smaller'>
                  <IntlMessages id='products.promoadd.descmaxchar' />
                </p>

                <Radio.Group
                  onChange={onDatePickChange}
                  value={radioDatePick}
                  style={{ marginBottom: 12 }}
                >
                  <Radio value={1}>Date Range Selection</Radio>
                  <Radio value={2}>Day Selection</Radio>
                </Radio.Group>

                {radioDatePick == 1 ? (
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment form-inner-pad-0'
                    name='formDate'
                    label={<IntlMessages id='products.promoadd.formdate' />}
                    rules={[
                      {
                        required: true,
                        message: (
                          <IntlMessages id='products.promoadd.alertdate' />
                        )
                      }
                    ]}
                  >
                    <RangePicker
                      size='large'
                      showTime={{ format: 'HH:mm' }}
                      format='YYYY-MM-DD HH:mm'
                      style={{ width: '100%' }}
                      inputReadOnly={true}
                    />
                  </Form.Item>
                ) : (
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment form-inner-pad-0'
                        name='daySelection'
                        label={'Day'}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id='products.promoadd.alertdate' />
                            )
                          }
                        ]}
                      >
                        <Select
                          placeholder='Select a day'
                          // onChange={handleDayChange}
                          // value={selectedDay}
                          style={{ width: '100%' }}
                        >
                          <Option value='Sunday'>Sunday</Option>
                          <Option value='Monday'>Monday</Option>
                          <Option value='Tuesday'>Tuesday</Option>
                          <Option value='Wednesday'>Wednesday</Option>
                          <Option value='Thursday'>Thursday</Option>
                          <Option value='Friday'>Friday</Option>
                          <Option value='Saturday'>Saturday</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment form-inner-pad-0'
                        name='timeRange'
                        label={'Time Range'}
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id='products.promoadd.alertdate' />
                            )
                          }
                        ]}
                      >
                        <TimePicker.RangePicker
                          format='HH:mm'
                          // onChange={handleTimeRangeChange}
                          // value={
                          //   timeRange.length
                          //     ? [
                          //         moment(timeRange[0], 'HH:mm'),
                          //         moment(timeRange[1], 'HH:mm')
                          //       ]
                          //     : null
                          // }
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Form>
            </Col>
            <Col lg={9} md={12} sm={24} xs={24}>
              <p className='custom-font-weight-500 dk-font-size-preview dk-mg-bt-5'>
                <IntlMessages id='products.promoadd.preview' />
              </p>

              <Card className='mbt-8'>
                <div className='d-flex align-items-center'>
                  <TagFilled />
                  <p className='mb-0 ml-2'>{cardPromoName}</p>
                </div>
                <p className='mb-0'>{getPromoDescPlace}</p>
                <Divider />
                <p className='mb-0'>
                  <IntlMessages id='products.promoadd.carddesc' />
                </p>
              </Card>

              <Form
                {...formItemLayout}
                name='promoForm'
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                scrollToFirstError
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment dk-review-outlet-promo form-inner-pad-0'
                  name='outlets'
                  label={<IntlMessages id='products.promoadd.out' />}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessages id='products.promoadd.selectout' />
                    }
                  ]}
                >
                  <Select
                    placeholder='Select an Outlet'
                    mode='multiple'
                    // style={{ width: "410px" }}
                    size='middle'
                    onDeselect={e =>
                      setOutletsDeSelect(getOutletsDeSelect.concat(e))
                    }
                    showSearch
                    optionFilterProp='children'
                  >
                    {getOutletsData &&
                      getOutletsData.map(e => {
                        return (
                          <Select.Option value={e.name} key={e.id}>
                            {e.name}
                          </Select.Option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
          </Row>

          <Divider className='mt-3 mb-4' />

          <Row>
            <Col lg={6} md={24} sm={24} xs={24}>
              <h2 className='custom-font-weight-500 custom-font-color-black'>
                <IntlMessages id='products.promoadd.promo' />
              </h2>
              <p className='dk-font-size-15'>
                <IntlMessages id='products.promoadd.promobrief' />
              </p>
            </Col>

            <Col lg={18} md={24} sm={24} xs={24}>
              <Row className='dk-flex-promo'>
                {advPromoAllow ? (
                  <>
                    <Col
                      lg={12}
                      md={12}
                      sm={12}
                      xs={24}
                      className='dk-flex-promo-1'
                    >
                      <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                        <Card
                          className={`${
                            selectedTestType == 1
                              ? 'ant-card-bordered-active'
                              : ''
                          }`}
                          onClick={() => cardClickFunction(1)}
                        >
                          <h3>
                            <IntlMessages id='products.promoadd.card1' />
                          </h3>
                          <Divider />
                          <p className='mb-0'>
                            <IntlMessages id='products.promoadd.cardtext1' />
                          </p>
                        </Card>
                      </div>
                    </Col>
                    <Col
                      lg={12}
                      md={12}
                      sm={12}
                      xs={24}
                      className='dk-flex-promo-1'
                    >
                      <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                        <Card
                          className={`${
                            selectedTestType == 2
                              ? 'ant-card-bordered-active'
                              : ''
                          }`}
                          onClick={() => cardClickFunction(2)}
                        >
                          <h3>
                            <IntlMessages id='products.promoadd.card2' />
                          </h3>
                          <Divider />
                          <p className='mb-0'>
                            <IntlMessages id='products.promoadd.cardtext2' />
                          </p>
                        </Card>
                      </div>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col lg={12} md={12} sm={12} xs={24}>
                      <div className='dk-custom-promoadd-card1'>
                        <Card
                          className={`${
                            selectedTestType == 1
                              ? 'ant-card-bordered-active'
                              : ''
                          }`}
                          onClick={() => cardClickFunction(1)}
                        >
                          <h3>
                            <IntlMessages id='products.promoadd.card1' />
                          </h3>
                          <Divider />
                          <p className='mb-0'>
                            <IntlMessages id='products.promoadd.cardtext1' />
                          </p>
                          <p className='mb-0'>a</p>
                        </Card>
                      </div>
                    </Col>
                  </>
                )}
              </Row>
              {getIsBasic && (
                <Card>
                  <Row>
                    <Col lg={4} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.get' />
                      </h2>
                    </Col>
                    <Col lg={12} md={24} sm={24} xs={24}>
                      <h3 className='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.discount' />
                      </h3>
                      <Row>
                        <Col lg={8} md={8} sm={24} xs={24}>
                          {' '}
                          <Radio.Group
                            options={disocuntOptions}
                            onChange={radBtnBasic}
                            optionType='button'
                            size='middle'
                            value={getBasicDisCardBtn}
                          />
                        </Col>
                        <Col lg={16} md={12} sm={24} xs={24}>
                          {getBasicIsPercent ? (
                            <Form
                              name='promoForm'
                              form={form}
                              onFinish={onFinish}
                              onFinishFailed={onFinishFailed}
                              scrollToFirstError
                            >
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                name='disPercent'
                                rules={[
                                  {
                                    required:
                                      getIsBasic && getBasicIsPercent
                                        ? true
                                        : false,
                                    message: (
                                      <IntlMessages id='products.promoadd.disperalert' />
                                    )
                                  }
                                ]}
                              >
                                <InputNumber
                                  type='number'
                                  // defaultValue={0.0}
                                  min={0}
                                  max={100}
                                  step={0.1}
                                  // formatter={(value) => `${value}%`}
                                  // parser={(value) => value.replace("%", "")}
                                  size='middle'
                                  style={{ width: '100%' }}
                                />
                              </Form.Item>
                            </Form>
                          ) : (
                            <Form
                              name='promoForm'
                              form={form}
                              onFinish={onFinish}
                              onFinishFailed={onFinishFailed}
                              scrollToFirstError
                            >
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                name='disCurrency'
                                rules={[
                                  {
                                    required:
                                      getIsBasic && !getBasicIsPercent
                                        ? true
                                        : false,
                                    message: (
                                      <IntlMessages id='products.promoadd.discurralert' />
                                    )
                                  }
                                ]}
                              >
                                <InputNumber
                                  type='number'
                                  // defaultValue={0.0}
                                  min={0}
                                  max={1000000000}
                                  step={0.5}
                                  // formatter={(value) =>
                                  //   `${value}${getCurrSymbol}`
                                  // }
                                  // parser={(value) =>
                                  //   value.replace(`${getCurrSymbol}.`, "")
                                  // }
                                  size='middle'
                                  style={{ width: '100%' }}
                                />
                              </Form.Item>
                            </Form>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={8} md={24} sm={24} xs={24}>
                      <h3 className='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.product' />
                      </h3>
                      <Radio.Group
                        options={productsOptions}
                        onChange={radBtnBasicForProd}
                        optionType='button'
                        size='middle'
                        value={getBasicDisCardProd}
                      />
                    </Col>
                  </Row>

                  {!getBasicIsAll && (
                    <>
                      <Divider className='mt-3 mb-4' />

                      <div className='Add-Filterproducts'>
                        <h3 className='custom-font-weight-500 custom-font-color-black mb-4'>
                          <IntlMessages id='products.promoadd.cardfilter' />
                        </h3>

                        <Row>
                          <Col lg={6} md={5} sm={24} xs={24} className='mb-3'>
                            <Dropdown overlay={prodDropDown}>
                              <Button className='custom-addpromo-filterbtn w-100'>
                                {getDropBtnName} <DownOutlined />
                              </Button>
                            </Dropdown>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={5} sm={24} xs={24} className='mb-3'>
                            <Dropdown overlay={searchDropDown}>
                              <Button className='custom-addpromo-filterbtn w-100'>
                                {Object.entries(PROD_SEARCH_ENTITIES).filter(
                                  q => q[1] == searchDropBtnName
                                ).length > 0
                                  ? Object.entries(PROD_SEARCH_ENTITIES)
                                      .filter(
                                        q => q[1] == searchDropBtnName
                                      )[0][0]
                                      .replaceAll('_', ' ')
                                  : ''}
                                <DownOutlined />
                              </Button>
                            </Dropdown>
                          </Col>

                          <Col
                            lg={18}
                            md={19}
                            sm={24}
                            xs={24}
                            className='m0-inner-row'
                          >
                            <ProductSearch
                              isLabel={false}
                              searchFrom={AUTOCOMPLETE_SEARCH_FROM.BASICPROMO}
                              noChild={true}
                              searchBy={searchDropBtnName}
                              isPromo={true}
                            />
                            {getAutoCompleteError && (
                              <>
                                <p className='custom-prod-specific-error'>
                                  <IntlMessages id='products.promoadd.autocomperror' />
                                </p>
                              </>
                            )}
                          </Col>
                        </Row>

                        <div className='custom-mg-top-10 mb-10'>
                          {selectedBasicPromoAdd &&
                            selectedBasicPromoAdd.map(e => {
                              let entityName = 'Product'
                              if (e.entityID) {
                                switch (
                                  isString(e.entityID)
                                    ? parseInt(e.entityID)
                                    : e.entityID
                                ) {
                                  case PROD_SEARCH_ENTITIES.Search_By_Brand: {
                                    entityName = 'Brand'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Category: {
                                    entityName = 'Category'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
                                    entityName = 'Supplier'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Tags: {
                                    entityName = 'Tag'
                                    break
                                  }
                                  default: {
                                    break
                                  }
                                }
                              }
                              return (
                                <Tag
                                  key={e.productID}
                                  className='custom-addpromo-tags'
                                  closable
                                  onClose={() =>
                                    basicDisTagClose(e.productName)
                                  }
                                >
                                  {`${entityName}: ${e.productName}`}
                                </Tag>
                              )
                            })}
                        </div>

                        <Row>
                          <Col lg={6} md={5} sm={24} xs={24} className='mb-3'>
                            {(selectedBasicPromoAdd.length > 0 ||
                              selectedBasicPromoAddExtraBtn.length > 0) && (
                              <>
                                <Button
                                  className='custom-addpromo-filterbtn w-100'
                                  onClick={extraIncludeExcludeBtn}
                                >
                                  <PlusCircleOutlined
                                    style={{
                                      display: 'inline-flex',
                                      marginRight: '4px'
                                    }}
                                  />
                                  {getWhichOptionSelect}
                                </Button>
                              </>
                            )}
                          </Col>
                          {getIsExclude && (
                            <>
                              <Col
                                lg={18}
                                md={19}
                                sm={24}
                                xs={24}
                                className='m0-inner-row'
                                // lg={6}
                                // md={5}
                                // sm={24}
                                // xs={24}
                                // className='mb-3'
                              >
                                <div className='del-btn-div flex-ruby-text'>
                                  <ProductSearch
                                    isLabel={false}
                                    searchFrom={
                                      AUTOCOMPLETE_SEARCH_FROM.BASICPROMOEXTRA
                                    }
                                    noChild={true}
                                    searchBy={searchDropBtnName}
                                    isPromo={true}
                                  />
                                  <a
                                    className='trash-icon-btn'
                                    onClick={BasicExtraBtnDelIcon}
                                  >
                                    <i className='icon icon-trash' />
                                  </a>
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>

                        <div className='custom-mg-top-10'>
                          {selectedBasicPromoAddExtraBtn &&
                            selectedBasicPromoAddExtraBtn.map(e => {
                              let entityName = 'Product'
                              if (e.entityID) {
                                switch (
                                  isString(e.entityID)
                                    ? parseInt(e.entityID)
                                    : e.entityID
                                ) {
                                  case PROD_SEARCH_ENTITIES.Search_By_Brand: {
                                    entityName = 'Brand'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Category: {
                                    entityName = 'Category'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
                                    entityName = 'Supplier'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Tags: {
                                    entityName = 'Tag'
                                    break
                                  }
                                  default: {
                                    break
                                  }
                                }
                              }
                              return (
                                <Tag
                                  key={e.productID}
                                  className='custom-addpromo-tags'
                                  closable
                                  onClose={() =>
                                    basicDisTagCloseExtraBtn(e.productName)
                                  }
                                >
                                  {`${entityName}: ${e.productName}`}
                                </Tag>
                              )
                            })}
                        </div>
                      </div>
                    </>
                  )}
                </Card>
              )}

              {getIsAdvance && (
                <Row className='custom-mg-bt'>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <h3 class='custom-font-weight-500 custom-font-color-black'>
                      <IntlMessages id='products.promoadd.whencus' />
                    </h3>
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Select
                      value={getWhenCusDropValue}
                      className='custom-addpromo-jackass'
                      onSelect={value => whenCusSelected(value)}
                      size='large'
                    >
                      {getWhenCustomer &&
                        getWhenCustomer.map(e => {
                          return (
                            <Select.Option
                              key={e.whenCusID}
                              value={e.whenCusID}
                              disabled={
                                e.whenCusID == 2 &&
                                form.getFieldValue('rewards') &&
                                form.getFieldValue('rewards').length > 0 &&
                                getDecryptID(
                                  form.getFieldValue('rewards')[1]
                                ) == '3'
                                  ? true
                                  : false
                              }
                            >
                              {e.whenCusName}
                            </Select.Option>
                          )
                        })}
                    </Select>
                  </Col>
                </Row>
              )}

              {getIsWhenCusBuy && (
                <Card>
                  <Row>
                    <Col lg={4} md={24} sm={24} xs={24}>
                      <h2 class='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.buy' />
                      </h2>
                    </Col>

                    <Col lg={12} md={24} sm={24} xs={24}>
                      <h3 class='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.quantity' />
                      </h3>
                      <Form
                        name='promoForm'
                        form={form}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                      >
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='advBuyQuantity'
                          rules={[
                            {
                              required:
                                getIsAdvance && getIsWhenCusBuy ? true : false,
                              message: (
                                <IntlMessages id='products.promoadd.advbuyquantity' />
                              )
                            }
                          ]}
                        >
                          <InputNumber
                            type='number'
                            // defaultValue={0}
                            min={0}
                            max={1000000}
                            step={1}
                            size='large'
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      </Form>
                    </Col>

                    <Col lg={8} md={24} sm={24} xs={24}>
                      <h3 class='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.product' />
                      </h3>
                      <Radio.Group
                        options={productsOptions}
                        onChange={radBtnAdvanceBuyForProd}
                        optionType='button'
                        size='large'
                        value={getAdvanceBuyCardProd}
                      />
                    </Col>
                  </Row>

                  {!getAdvanceBuyIsAll && (
                    <>
                      <Divider className='custom-mgt-mgb-20' />

                      <div>
                        <h3 class='custom-font-weight-500 custom-font-color-black'>
                          <IntlMessages id='products.promoadd.cardfilter' />
                        </h3>

                        <Row>
                          <Col lg={6} md={5} sm={24} xs={24} className='mb-3'>
                            <Dropdown overlay={prodDropDown}>
                              <Button className='custom-addpromo-filterbtn w-100'>
                                {getDropBtnName} <DownOutlined />
                              </Button>
                            </Dropdown>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={6} md={5} sm={24} xs={24} className='mb-3'>
                            <Dropdown overlay={searchDropDown}>
                              <Button className='custom-addpromo-filterbtn w-100'>
                                {Object.entries(PROD_SEARCH_ENTITIES).filter(
                                  q => q[1] == searchDropBtnName
                                ).length > 0
                                  ? Object.entries(PROD_SEARCH_ENTITIES)
                                      .filter(
                                        q => q[1] == searchDropBtnName
                                      )[0][0]
                                      .replaceAll('_', ' ')
                                  : ''}
                                <DownOutlined />
                              </Button>
                            </Dropdown>
                          </Col>

                          <Col
                            lg={18}
                            md={19}
                            sm={24}
                            xs={24}
                            className='m0-inner-row'
                          >
                            <ProductSearch
                              isLabel={false}
                              searchFrom={
                                AUTOCOMPLETE_SEARCH_FROM.ADVANCEBUYPROMO
                              }
                              noChild={true}
                              searchBy={searchDropBtnName}
                              isPromo={true}
                            />

                            {getAutoCompleteError && (
                              <>
                                <p className='custom-prod-specific-error'>
                                  <IntlMessages id='products.promoadd.autocomperror' />
                                </p>
                              </>
                            )}
                          </Col>
                        </Row>

                        <div className='custom-mg-top-10 mb-10'>
                          {selectedAdvanceBuyPromoAdd &&
                            selectedAdvanceBuyPromoAdd.map(e => {
                              let entityName = 'Product'
                              if (e.entityID) {
                                switch (
                                  isString(e.entityID)
                                    ? parseInt(e.entityID)
                                    : e.entityID
                                ) {
                                  case PROD_SEARCH_ENTITIES.Search_By_Brand: {
                                    entityName = 'Brand'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Category: {
                                    entityName = 'Category'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
                                    entityName = 'Supplier'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Tags: {
                                    entityName = 'Tag'
                                    break
                                  }
                                  default: {
                                    break
                                  }
                                }
                              }
                              return (
                                <Tag
                                  key={e.productID}
                                  className='custom-addpromo-tags'
                                  closable
                                  onClose={() =>
                                    advanceBuyTagClose(e.productName)
                                  }
                                >
                                  {`${entityName}: ${e.productName}`}
                                </Tag>
                              )
                            })}
                        </div>
                      </div>

                      <Row>
                        <Col md={4} xs={8}>
                          {(selectedAdvanceBuyPromoAdd.length > 0 ||
                            selectedAdvBuyPromoAddExtraBtn.length > 0) && (
                            <>
                              <Button
                                className='custom-addpromo-filterbtn w-100'
                                onClick={advBuyextraIncludeExcludeBtn}
                              >
                                <PlusCircleOutlined
                                  style={{
                                    display: 'inline-flex',
                                    marginRight: '2px'
                                  }}
                                />
                                {getWhichOptionSelect}
                              </Button>
                            </>
                          )}
                        </Col>
                        {getAdvanceBuyIsExclude && (
                          <>
                            <Col
                              lg={18}
                              md={19}
                              sm={24}
                              xs={24}
                              className='m0-inner-row'
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between'
                                }}
                              >
                                <ProductSearch
                                  isLabel={false}
                                  searchFrom={
                                    AUTOCOMPLETE_SEARCH_FROM.ADVANCEBUYPROMOEXTRA
                                  }
                                  noChild={true}
                                  searchBy={searchDropBtnName}
                                  isPromo={true}
                                />

                                <a
                                  className='trash-icon-btn'
                                  onClick={AdvBuyExtraBtnDelIcon}
                                >
                                  <i
                                    className='icon icon-trash'
                                    style={{ fontSize: '20px' }}
                                  />
                                </a>
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>

                      <div className='custom-mg-top-10'>
                        {selectedAdvBuyPromoAddExtraBtn &&
                          selectedAdvBuyPromoAddExtraBtn.map(e => {
                            let entityName = 'Product'
                            if (e.entityID) {
                              switch (
                                isString(e.entityID)
                                  ? parseInt(e.entityID)
                                  : e.entityID
                              ) {
                                case PROD_SEARCH_ENTITIES.Search_By_Brand: {
                                  entityName = 'Brand'
                                  break
                                }
                                case PROD_SEARCH_ENTITIES.Search_By_Category: {
                                  entityName = 'Category'
                                  break
                                }
                                case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
                                  entityName = 'Supplier'
                                  break
                                }
                                case PROD_SEARCH_ENTITIES.Search_By_Tags: {
                                  entityName = 'Tag'
                                  break
                                }
                                default: {
                                  break
                                }
                              }
                            }
                            return (
                              <Tag
                                key={e.productID}
                                className='custom-addpromo-tags'
                                closable
                                onClose={() =>
                                  advBuyTagCloseExtraBtn(e.productName)
                                }
                              >
                                {`${entityName}: ${e.productName}`}
                              </Tag>
                            )
                          })}
                      </div>
                    </>
                  )}
                </Card>
              )}

              {getIsWhenCusSpend && (
                <Card>
                  <Row>
                    <Col lg={4} md={24} sm={24} xs={24}>
                      <h2 class='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.spend' />
                      </h2>
                    </Col>

                    <Col lg={12} md={24} sm={24} xs={24}>
                      <h3 class='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.amount' />
                      </h3>
                      <Form
                        name='promoForm'
                        form={form}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                      >
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='advSpendAmount'
                          rules={[
                            {
                              required:
                                getIsAdvance && getIsWhenCusSpend
                                  ? true
                                  : false,
                              message: (
                                <IntlMessages id='products.promoadd.advspendamount' />
                              )
                            }
                          ]}
                        >
                          <InputNumber
                            type='number'
                            // defaultValue={0}
                            min={0}
                            max={1000000}
                            step={1}
                            size='large'
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      </Form>
                    </Col>

                    <Col lg={8} md={24} sm={24} xs={24}>
                      <h3 class='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.product' />
                      </h3>
                      <Radio.Group
                        options={productsOptions}
                        onChange={radBtnAdvanceSpendForProd}
                        optionType='button'
                        size='large'
                        value={getAdvanceSpendCardProd}
                      />
                    </Col>
                  </Row>
                  {!getAdvanceSpendIsAll && (
                    <>
                      <Divider className='custom-mgt-mgb-20' />
                      <div>
                        <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                          <IntlMessages id='products.promoadd.cardfilter' />
                        </h2>
                        <Row>
                          <Col lg={6} md={5} sm={24} xs={24} className='mb-3'>
                            <Dropdown overlay={prodDropDown}>
                              <Button className='custom-addpromo-filterbtn w-100'>
                                {getDropBtnName} <DownOutlined />
                              </Button>
                            </Dropdown>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={5} sm={24} xs={24} className='mb-3'>
                            <Dropdown overlay={searchDropDown}>
                              <Button className='custom-addpromo-filterbtn w-100'>
                                {Object.entries(PROD_SEARCH_ENTITIES).filter(
                                  q => q[1] == searchDropBtnName
                                ).length > 0
                                  ? Object.entries(PROD_SEARCH_ENTITIES)
                                      .filter(
                                        q => q[1] == searchDropBtnName
                                      )[0][0]
                                      .replaceAll('_', ' ')
                                  : ''}
                                <DownOutlined />
                              </Button>
                            </Dropdown>
                          </Col>

                          <Col
                            lg={18}
                            md={19}
                            sm={24}
                            xs={24}
                            className='m0-inner-row'
                          >
                            <ProductSearch
                              isLabel={false}
                              searchFrom={
                                AUTOCOMPLETE_SEARCH_FROM.ADVANCESPENDPROMO
                              }
                              noChild={true}
                              searchBy={searchDropBtnName}
                              isPromo={true}
                            />

                            {getAutoCompleteError && (
                              <>
                                <p className='custom-prod-specific-error'>
                                  <IntlMessages id='products.promoadd.autocomperror' />
                                </p>
                              </>
                            )}
                          </Col>
                        </Row>

                        <div className='custom-mg-top-10 mb-10'>
                          {selectedAdvanceSpendPromoAdd &&
                            selectedAdvanceSpendPromoAdd.map(e => {
                              let entityName = 'Product'
                              if (e.entityID) {
                                switch (
                                  isString(e.entityID)
                                    ? parseInt(e.entityID)
                                    : e.entityID
                                ) {
                                  case PROD_SEARCH_ENTITIES.Search_By_Brand: {
                                    entityName = 'Brand'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Category: {
                                    entityName = 'Category'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
                                    entityName = 'Supplier'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Tags: {
                                    entityName = 'Tag'
                                    break
                                  }
                                  default: {
                                    break
                                  }
                                }
                              }
                              return (
                                <Tag
                                  key={e.productID}
                                  className='custom-addpromo-tags'
                                  closable
                                  onClose={() =>
                                    advanceSpendTagClose(e.productName)
                                  }
                                >
                                  {`${entityName}: ${e.productName}`}
                                </Tag>
                              )
                            })}
                        </div>

                        <Row>
                          <Col md={4} xs={8}>
                            {(selectedAdvanceSpendPromoAdd.length > 0 ||
                              selectedAdvSpendPromoAddExtraBtn.length > 0) && (
                              <>
                                <Button
                                  className='custom-addpromo-filterbtn w-100'
                                  onClick={advSpendextraIncludeExcludeBtn}
                                >
                                  <PlusCircleOutlined
                                    style={{
                                      display: 'inline-flex',
                                      marginRight: '2px'
                                    }}
                                  />
                                  {getWhichOptionSelect}
                                </Button>
                              </>
                            )}
                          </Col>
                          {getAdvanceSpendIsExclude && (
                            <>
                              <Col
                                lg={18}
                                md={19}
                                sm={24}
                                xs={24}
                                className='m0-inner-row'
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <ProductSearch
                                    isLabel={false}
                                    searchFrom={
                                      AUTOCOMPLETE_SEARCH_FROM.ADVANCESPENDPROMOEXTRA
                                    }
                                    noChild={true}
                                    searchBy={searchDropBtnName}
                                    isPromo={true}
                                  />

                                  <a
                                    className='trash-icon-btn'
                                    onClick={AdvSpendExtraBtnDelIcon}
                                  >
                                    <i
                                      className='icon icon-trash'
                                      style={{ fontSize: '20px' }}
                                    />
                                  </a>
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                        <div className='custom-mg-top-10'>
                          {selectedAdvSpendPromoAddExtraBtn &&
                            selectedAdvSpendPromoAddExtraBtn.map(e => {
                              let entityName = 'Product'
                              if (e.entityID) {
                                switch (
                                  isString(e.entityID)
                                    ? parseInt(e.entityID)
                                    : e.entityID
                                ) {
                                  case PROD_SEARCH_ENTITIES.Search_By_Brand: {
                                    entityName = 'Brand'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Category: {
                                    entityName = 'Category'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
                                    entityName = 'Supplier'
                                    break
                                  }
                                  case PROD_SEARCH_ENTITIES.Search_By_Tags: {
                                    entityName = 'Tag'
                                    break
                                  }
                                  default: {
                                    break
                                  }
                                }
                              }
                              return (
                                <Tag
                                  key={e.productID}
                                  className='custom-addpromo-tags'
                                  closable
                                  onClose={() =>
                                    advSpendTagCloseExtraBtn(e.productName)
                                  }
                                >
                                  {`${entityName}: ${e.productName}`}
                                </Tag>
                              )
                            })}
                        </div>
                      </div>
                    </>
                  )}
                </Card>
              )}

              {getIsReward && (
                <>
                  <Row className='custom-mg-bt'>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <h3 class='custom-font-weight-500 custom-font-color-black'>
                        <IntlMessages id='products.promoadd.thenthey' />
                      </h3>
                    </Col>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Form
                        {...formItemLayout}
                        form={form}
                        name='promoForm'
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                      >
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment custom-addpromo-jackass dk-padding-0'
                          name='rewards'
                          rules={[
                            {
                              required:
                                getIsAdvance && getIsReward ? true : false,
                              message: (
                                <IntlMessages id='products.promoadd.rewardselectalert' />
                              )
                            }
                          ]}
                        >
                          <Select
                            placeholder={getRewardDropValue}
                            onSelect={(key, value) =>
                              whenRewardSelected(key, value)
                            }
                            size='large'
                          >
                            {getRewards &&
                              getRewards.map(e => {
                                return (
                                  <Select.Option
                                    key={e.id}
                                    value={[e.name, e.id]}
                                    disabled={
                                      getIsWhenCusSpend &&
                                      e.id.substring(0, e.id.indexOf('&')) ==
                                        '3'
                                    }
                                  >
                                    {e.name}
                                  </Select.Option>
                                )
                              })}
                          </Select>
                        </Form.Item>
                      </Form>
                    </Col>
                  </Row>

                  {getIsRewardGetKind && (
                    <Card>
                      <Row>
                        <Col lg={4} md={24} sm={24} xs={24}>
                          <h2 class='custom-font-weight-500 custom-font-color-black'>
                            <IntlMessages id='products.promoadd.get' />
                          </h2>
                        </Col>

                        <Col lg={12} md={24} sm={24} xs={24}>
                          <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <h3 class='custom-font-weight-500 custom-font-color-black'>
                                <IntlMessages id='products.promoadd.discount' />
                              </h3>
                              <Radio.Group
                                options={rewardDisocuntOptions}
                                onChange={radBtnRewardDiscount}
                                optionType='button'
                                size='middle'
                                value={getRewardDisCardBtn}
                              />
                            </Col>

                            <Col lg={24} md={24} sm={24} xs={24}>
                              {getIsRewardGetFree && (
                                <>
                                  <h3 class='custom-font-weight-500 custom-font-color-black'>
                                    <IntlMessages id='products.promoadd.quantity' />
                                  </h3>
                                  <Form
                                    name='promoForm'
                                    form={form}
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFailed}
                                    scrollToFirstError
                                  >
                                    <Form.Item
                                      className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                      name='rewGetFree'
                                      rules={[
                                        {
                                          required:
                                            getIsAdvance &&
                                            getIsReward &&
                                            getIsRewardGetKind &&
                                            getIsRewardGetFree
                                              ? true
                                              : false,
                                          message: (
                                            <IntlMessages id='products.promoadd.disperalert' />
                                          )
                                        }
                                      ]}
                                    >
                                      <InputNumber
                                        type='number'
                                        // defaultValue={0}
                                        min={0}
                                        max={1000000}
                                        step={1}
                                        size='middle'
                                        className='w-100'
                                      />
                                    </Form.Item>
                                  </Form>
                                </>
                              )}

                              {getIsRewardGetPercent && (
                                <>
                                  <Row>
                                    <Col
                                      lg={24}
                                      md={24}
                                      sm={24}
                                      xs={24}
                                      className='mt-3'
                                    >
                                      <h3 class='custom-font-weight-500 custom-font-color-black'>
                                        <IntlMessages id='products.promoadd.percent' />
                                      </h3>
                                      <Form
                                        name='promoForm'
                                        form={form}
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        scrollToFirstError
                                      >
                                        <Form.Item
                                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                          name='rewGetPercent'
                                          rules={[
                                            {
                                              required:
                                                getIsAdvance &&
                                                getIsReward &&
                                                getIsRewardGetKind &&
                                                getIsRewardGetPercent
                                                  ? true
                                                  : false,
                                              message: (
                                                <IntlMessages id='products.promoadd.disperalert' />
                                              )
                                            }
                                          ]}
                                        >
                                          <InputNumber
                                            type='number'
                                            // defaultValue={0.0}
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            // formatter={(value) => `${value}%`}
                                            // parser={(value) =>
                                            //   value.replace("%", "")
                                            // }
                                            size='middle'
                                            style={{ width: '100%' }}
                                          />
                                        </Form.Item>
                                      </Form>
                                    </Col>

                                    <Col
                                      lg={24}
                                      md={24}
                                      sm={24}
                                      xs={24}
                                      className='mt-3'
                                    >
                                      <h3 class='custom-font-weight-500 custom-font-color-black'>
                                        <IntlMessages id='products.promoadd.quantity' />
                                      </h3>
                                      <Form
                                        name='promoForm'
                                        form={form}
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        scrollToFirstError
                                      >
                                        <Form.Item
                                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                          name='rewGetDiscount'
                                          rules={[
                                            {
                                              required:
                                                getIsAdvance &&
                                                getIsReward &&
                                                getIsRewardGetKind &&
                                                getIsRewardGetPercent
                                                  ? true
                                                  : false,
                                              message: (
                                                <IntlMessages id='products.promoadd.advbuyquantity' />
                                              )
                                            }
                                          ]}
                                        >
                                          <InputNumber
                                            type='number'
                                            // defaultValue={0}
                                            min={0}
                                            max={1000000}
                                            step={1}
                                            size='middle'
                                            style={{ width: '100%' }}
                                          />
                                        </Form.Item>
                                      </Form>
                                    </Col>
                                  </Row>
                                </>
                              )}

                              {getIsRewardGetAmount && (
                                <>
                                  <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                      <h2>
                                        <IntlMessages id='products.promoadd.amount' />
                                      </h2>
                                      <Form
                                        name='promoForm'
                                        form={form}
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        scrollToFirstError
                                      >
                                        <Form.Item
                                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                          name='rewGetAmount'
                                          rules={[
                                            {
                                              required:
                                                getIsAdvance &&
                                                getIsReward &&
                                                getIsRewardGetKind &&
                                                getIsRewardGetAmount
                                                  ? true
                                                  : false,
                                              message: (
                                                <IntlMessages id='products.promoadd.advspendamount' />
                                              )
                                            }
                                          ]}
                                        >
                                          <InputNumber
                                            type='number'
                                            // defaultValue={0.0}
                                            min={0}
                                            max={1000000000}
                                            step={0.5}
                                            // formatter={(value) =>
                                            //   `${value}${getCurrSymbol}`
                                            // }
                                            // parser={(value) =>
                                            //   value.replace(
                                            //     `${getCurrSymbol}.`,
                                            //     ""
                                            //   )
                                            // }
                                            size='middle'
                                            style={{ width: '100%' }}
                                          />
                                        </Form.Item>
                                      </Form>
                                    </Col>

                                    <Col lg={24} md={24} sm={24} xs={24}>
                                      <h2>
                                        <IntlMessages id='products.promoadd.quantity' />
                                      </h2>
                                      <Form
                                        name='promoForm'
                                        form={form}
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        scrollToFirstError
                                      >
                                        <Form.Item
                                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                          name='rewGetAmountDis'
                                          rules={[
                                            {
                                              required:
                                                getIsAdvance &&
                                                getIsReward &&
                                                getIsRewardGetKind &&
                                                getIsRewardGetAmount
                                                  ? true
                                                  : false,
                                              message: (
                                                <IntlMessages id='products.promoadd.advbuyquantity' />
                                              )
                                            }
                                          ]}
                                        >
                                          <InputNumber
                                            type='number'
                                            // defaultValue={0}
                                            min={0}
                                            max={1000000}
                                            step={1}
                                            size='middle'
                                            style={{ width: '100%' }}
                                          />
                                        </Form.Item>
                                      </Form>
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Col>
                          </Row>
                        </Col>

                        <Col lg={8} md={24} sm={24} xs={24}>
                          <div>
                            {' '}
                            <h3 class='custom-font-weight-500 custom-font-color-black'>
                              <IntlMessages id='products.promoadd.product' />
                            </h3>
                            <Radio.Group
                              options={productsOptions}
                              onChange={radBtnAdvanceRewardForProd}
                              optionType='button'
                              size='middle'
                              value={getAdvanceRewardCardProd}
                            />
                          </div>
                        </Col>
                      </Row>

                      {!getAdvanceRewardIsAll && (
                        <>
                          <Divider className='custom-mgt-mgb-20' />

                          <div>
                            <h3 class='custom-font-weight-500 custom-font-color-black'>
                              Filter products by Product Name
                              {/* <IntlMessages id='products.promoadd.cardfilter' /> */}
                            </h3>

                            {/* <Row>
                              <Col
                                lg={6}
                                md={5}
                                sm={24}
                                xs={24}
                                className='mb-3'
                              >
                                <Dropdown overlay={prodDropDownForReward}>
                                  <Button className='custom-addpromo-filterbtn w-100'>
                                    {getDropBtnNameForReward} <DownOutlined />
                                  </Button>
                                </Dropdown>
                              </Col>
                            </Row> */}

                            <Row>
                              <Col
                                lg={6}
                                md={5}
                                sm={24}
                                xs={24}
                                className='mb-3'
                              >
                                <Dropdown overlay={prodDropDownForReward}>
                                  <Button className='custom-addpromo-filterbtn w-100'>
                                    {getDropBtnNameForReward} <DownOutlined />
                                  </Button>
                                </Dropdown>
                                {/* <Dropdown overlay={searchDropDown}>
                                  <Button className='custom-addpromo-filterbtn w-100'>
                                    {Object.entries(
                                      PROD_SEARCH_ENTITIES
                                    ).filter(q => q[1] == searchDropBtnName)
                                      .length > 0
                                      ? Object.entries(PROD_SEARCH_ENTITIES)
                                          .filter(
                                            q => q[1] == searchDropBtnName
                                          )[0][0]
                                          .replaceAll('_', ' ')
                                      : ''}
                                    <DownOutlined />
                                  </Button>
                                </Dropdown> */}
                              </Col>

                              <Col
                                lg={18}
                                md={19}
                                sm={24}
                                xs={24}
                                className='m0-inner-row'
                              >
                                <ProductSearch
                                  isLabel={false}
                                  searchFrom={
                                    AUTOCOMPLETE_SEARCH_FROM.REWARDADD
                                  }
                                  noChild={true}
                                  // searchBy={searchDropBtnName}
                                  // isPromo={true}
                                />
                                {getRewardAutoCompleteError && (
                                  <>
                                    <p className='custom-prod-specific-error'>
                                      <IntlMessages id='products.promoadd.autocomperror' />
                                    </p>
                                  </>
                                )}
                              </Col>
                            </Row>

                            <div className='custom-mg-top-10 mb-10'>
                              {selectedAdvanceRewardAdd &&
                                selectedAdvanceRewardAdd.map(e => {
                                  let entityName = 'Product'
                                  if (e.entityID) {
                                    switch (
                                      isString(e.entityID)
                                        ? parseInt(e.entityID)
                                        : e.entityID
                                    ) {
                                      case PROD_SEARCH_ENTITIES.Search_By_Brand: {
                                        entityName = 'Brand'
                                        break
                                      }
                                      case PROD_SEARCH_ENTITIES.Search_By_Category: {
                                        entityName = 'Category'
                                        break
                                      }
                                      case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
                                        entityName = 'Supplier'
                                        break
                                      }
                                      case PROD_SEARCH_ENTITIES.Search_By_Tags: {
                                        entityName = 'Tag'
                                        break
                                      }
                                      default: {
                                        break
                                      }
                                    }
                                  }
                                  return (
                                    <Tag
                                      key={e.productID}
                                      className='custom-addpromo-tags'
                                      closable
                                      onClose={() =>
                                        advanceRewardTagClose(e.productName)
                                      }
                                    >
                                      {`${entityName}: ${e.productName}`}
                                    </Tag>
                                  )
                                })}
                            </div>

                            {/* exclude button work for get item reward */}

                            {/* <Row>
                              <Col lg={8} md={8} sm={12} xs={24}>
                                {(selectedAdvanceRewardAdd.length > 0 ||
                                  selectedAdvRewardAddExtraBtn.length > 0) && (
                                  <>
                                    <Button
                                      className='custom-addpromo-filterbtn w-100'
                                      onClick={advRewardEextraIncludeExcludeBtn}
                                    >
                                      <PlusCircleOutlined
                                        style={{
                                          display: 'inline-flex',
                                          marginRight: '2px'
                                        }}
                                      />
                                      {getWhichOptionSelectForReward}
                                    </Button>
                                  </>
                                )}
                              </Col>
                              {getAdvanceRewardIsExclude && (
                                <>
                                  <Col
                                    lg={18}
                                    md={19}
                                    sm={24}
                                    xs={24}
                                    className='m0-inner-row'
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                      }}
                                    >
                                      <ProductSearch
                                        isLabel={false}
                                        searchFrom={
                                          AUTOCOMPLETE_SEARCH_FROM.ADVREWARDEXTRA
                                        }
                                        noChild={true}
                                        searchBy={searchDropBtnName}
                                        isPromo={true}
                                      />
                                      <a
                                        className='trash-icon-btn'
                                        onClick={AdvRewardExtraBtnDelIcon}
                                      >
                                        <i
                                          className='icon icon-trash'
                                          style={{ fontSize: '20px' }}
                                        />
                                      </a>
                                    </div>
                                  </Col>
                                </>
                              )}
                            </Row>
                            <div className='custom-mg-top-10'>
                              {selectedAdvRewardAddExtraBtn &&
                                selectedAdvRewardAddExtraBtn.map(e => {
                                  let entityName = 'Product'
                                  if (e.entityID) {
                                    switch (e.entityID) {
                                      case PROD_SEARCH_ENTITIES.Search_By_Brand: {
                                        entityName = 'Brand'
                                        break
                                      }
                                      case PROD_SEARCH_ENTITIES.Search_By_Category: {
                                        entityName = 'Category'
                                        break
                                      }
                                      case PROD_SEARCH_ENTITIES.Search_By_Supplier: {
                                        entityName = 'Supplier'
                                        break
                                      }
                                      case PROD_SEARCH_ENTITIES.Search_By_Tags: {
                                        entityName = 'Tag'
                                        break
                                      }
                                      default: {
                                        break
                                      }
                                    }
                                  }
                                  return (
                                    <Tag
                                      key={e.productID}
                                      className='custom-addpromo-tags'
                                      closable
                                      onClose={() =>
                                        advRewardTagCloseExtraBtn(e.productName)
                                      }
                                    >
                                      {`${entityName}: ${e.productName}`}
                                    </Tag>
                                  )
                                })}
                            </div> */}
                          </div>
                        </>
                      )}
                    </Card>
                  )}

                  {getIsRewardSave && (
                    <Card>
                      <Row>
                        <Col lg={4} md={24} sm={24} xs={24}>
                          <h2 class='custom-font-weight-500 custom-font-color-black'>
                            <IntlMessages id='products.promoadd.rewardsave' />
                          </h2>
                        </Col>

                        <Col lg={12} md={24} sm={24} xs={24}>
                          <h3 class='custom-font-weight-500 custom-font-color-black'>
                            <IntlMessages id='products.promoadd.amount' />
                          </h3>
                          <Row>
                            <Col lg={8} md={8} sm={12} xs={24}>
                              <Radio.Group
                                options={disocuntOptions}
                                onChange={radBtnRewardSave}
                                optionType='button'
                                size='middle'
                                value={getRewardSaveBtn}
                              />
                            </Col>
                            <Col lg={16} md={12} sm={12} xs={24}>
                              {getRewardSaveIsPercent ? (
                                <Form
                                  name='promoForm'
                                  form={form}
                                  scrollToFirstError
                                  onFinish={onFinish}
                                  onFinishFailed={onFinishFailed}
                                >
                                  <Form.Item
                                    className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                    name='rewSavePercent'
                                    rules={[
                                      {
                                        required:
                                          getIsAdvance &&
                                          getIsReward &&
                                          getIsRewardSave &&
                                          getRewardSaveIsPercent
                                            ? true
                                            : false,
                                        message: (
                                          <IntlMessages id='products.promoadd.disperalert' />
                                        )
                                      }
                                    ]}
                                  >
                                    <InputNumber
                                      type='number'
                                      // defaultValue={0.0}
                                      min={0}
                                      max={100}
                                      step={0.1}
                                      // formatter={(value) => `${value}%`}
                                      // parser={(value) =>
                                      //   value.replace("%", "")
                                      // }
                                      size='middle'
                                      className='w-100'
                                    />
                                  </Form.Item>
                                </Form>
                              ) : (
                                <Form
                                  name='promoForm'
                                  form={form}
                                  scrollToFirstError
                                  onFinish={onFinish}
                                  onFinishFailed={onFinishFailed}
                                >
                                  <Form.Item
                                    className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                    name='rewSaveAmount'
                                    rules={[
                                      {
                                        required:
                                          getIsAdvance &&
                                          getIsReward &&
                                          getIsRewardSave &&
                                          !getRewardSaveIsPercent
                                            ? true
                                            : false,
                                        message: (
                                          <IntlMessages id='products.promoadd.discurralert' />
                                        )
                                      }
                                    ]}
                                  >
                                    <InputNumber
                                      type='number'
                                      // defaultValue={0.0}
                                      min={0}
                                      max={1000000000}
                                      step={0.5}
                                      // formatter={(value) =>
                                      //   `${value}${getCurrSymbol}`
                                      // }
                                      // parser={(value) =>
                                      //   value.replace(
                                      //     `${getCurrSymbol}.`,
                                      //     ""
                                      //   )
                                      // }
                                      size='middle'
                                      className='w-100'
                                    />
                                  </Form.Item>
                                </Form>
                              )}
                            </Col>
                          </Row>
                        </Col>

                        <Col lg={8} md={24} sm={24} xs={24}>
                          <p className=''>
                            <IntlMessages id='products.promoadd.rewsavetext' />
                          </p>
                        </Col>
                      </Row>
                    </Card>
                  )}
                  {getIsRewardFixed && (
                    <Row>
                      <Col span={24}>
                        <Card>
                          <Row>
                            <Col lg={4} md={4} sm={4} xs={24}>
                              <h2 class='custom-font-weight-500 custom-font-color-black'>
                                <IntlMessages id='products.promoadd.rewardpayfor' />
                              </h2>
                            </Col>

                            <Col lg={20} md={20} sm={20} xs={24}>
                              <h3 class='custom-font-weight-500 custom-font-color-black'>
                                <IntlMessages id='products.promoadd.amount' />
                              </h3>
                              <Form
                                name='promoForm'
                                form={form}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                scrollToFirstError
                              >
                                <Form.Item
                                  className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                                  name='rewFixAmount'
                                  rules={[
                                    {
                                      required:
                                        getIsAdvance &&
                                        getIsReward &&
                                        getIsRewardFixed
                                          ? true
                                          : false,
                                      message: (
                                        <IntlMessages id='products.promoadd.advspendamount' />
                                      )
                                    }
                                  ]}
                                >
                                  <InputNumber
                                    type='number'
                                    // defaultValue={0.0}
                                    min={0}
                                    max={1000000000}
                                    step={0.5}
                                    // formatter={(value) =>
                                    //   `${value}${getCurrSymbol}`
                                    // }
                                    // parser={(value) =>
                                    //   value.replace(`${getCurrSymbol}.`, "")
                                    // }
                                    size='large'
                                    className='w-100'
                                  />
                                </Form.Item>
                              </Form>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </Col>
          </Row>

          <Divider className='mt-3 mb-4' />

          {getIsAdvance && (
            <>
              <Row>
                <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                    <IntlMessages id='products.promoadd.cardshowprompt' />
                  </h2>
                  <p className='dk-font-size-15'>
                    <IntlMessages id='products.promoadd.carddescshow' />
                  </p>
                </Col>

                <Col lg={18} md={12} sm={24} xs={24}>
                  <Checkbox
                    checked={getIsShowPromptOnSellScreen}
                    onChange={checkBox}
                  >
                    <IntlMessages id='products.promoadd.checkbox' />
                  </Checkbox>
                </Col>
              </Row>
              <Divider />
            </>
          )}

          <Row>
            <Col lg={6} md={24} sm={24} xs={24}>
              <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                <IntlMessages id='products.promoadd.target' />
              </h2>
              <p className='dk-font-size-15'>
                <IntlMessages id='products.promoadd.targetbrief' />
              </p>
            </Col>
            <Col lg={18} md={24} sm={24} xs={24}>
              <Row className='dk-flex-promo'>
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={24}
                  className='dk-flex-promo-1'
                >
                  <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                    <Card
                      className={`${
                        selectedCus == 1 ? 'ant-card-bordered-active' : ''
                      }`}
                      onClick={() => secondCardClickFunction(1)}
                    >
                      <h3>
                        <IntlMessages id='products.promoadd.tarcard1' />
                      </h3>
                      <Divider />
                      <p className='mb-0'>
                        <IntlMessages id='products.promoadd.tarcardtext1' />
                      </p>
                    </Card>
                  </div>
                </Col>
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={24}
                  className='dk-flex-promo-1'
                >
                  <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                    <Card
                      className={`${
                        selectedCus == 2 ? 'ant-card-bordered-active' : ''
                      }`}
                      onClick={() => secondCardClickFunction(2)}
                    >
                      <h3>
                        <IntlMessages id='products.promoadd.tarcard2' />
                      </h3>
                      <Divider />
                      <p className='mb-0'>
                        <IntlMessages id='products.promoadd.tarcardtext2' />
                      </p>
                    </Card>
                  </div>
                </Col>
              </Row>

              {!getIsEveryone && (
                <>
                  <div className='div-flow'>
                    <Radio.Group
                      name='CusRadio'
                      onChange={exclusiveRadioBtn}
                      value={getExclusiveCusValue}
                    >
                      <Radio className='custom-addpromo-radio' value={1}>
                        <IntlMessages id='products.promoadd.checkboxtext1' />
                      </Radio>{' '}
                      <p className='custom-addpromo-radiobtndesc'>
                        <IntlMessages id='products.promoadd.checkboxdesc1' />
                      </p>
                    </Radio.Group>

                    {getExclusiveCusValue == 1 && (
                      <div>
                        <Row>
                          <p className='custom-addpromo-cusdropdown'>
                            <IntlMessages id='products.promoadd.cusdropdown' />
                          </p>
                          <Col md={24} xs={24}>
                            <Form
                              {...formItemLayout}
                              form={form}
                              name='promoForm'
                              scrollToFirstError
                              onFinish={onFinish}
                              onFinishFailed={onFinishFailed}
                            >
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                                name='customers'
                                rules={[
                                  {
                                    required:
                                      getExclusiveCusValue == 1 &&
                                      !getIsEveryone
                                        ? true
                                        : false,
                                    message: (
                                      <IntlMessages id='products.promoadd.alertcusgroup' />
                                    )
                                  }
                                ]}
                              >
                                <Select
                                  placeholder='Select a Customer Group'
                                  mode='multiple'
                                  onDeselect={e =>
                                    setCusGroupsDeSelect(
                                      getCusGroupsDeSelect.concat(e)
                                    )
                                  }
                                  className='w-100'
                                  showSearch
                                  optionFilterProp='children'
                                >
                                  {getCustomersData &&
                                    getCustomersData.map(e => {
                                      return (
                                        <Select.Option
                                          value={e.name}
                                          key={e.id}
                                        >
                                          {e.name}
                                        </Select.Option>
                                      )
                                    })}
                                </Select>
                              </Form.Item>
                            </Form>
                          </Col>
                        </Row>
                      </div>
                    )}
                    <h1></h1>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Spin>
    </div>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default PromoAdd
